/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as PortalRouteImport } from './routes/_portal'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as PublicTenantFallbackRouteImport } from './routes/_public/tenant-fallback'
import { Route as PublicMaintenanceRouteImport } from './routes/_public/maintenance'
import { Route as PublicHelpDeskUnlogRouteImport } from './routes/_public/help-desk-unlog'
import { Route as PublicDownloadAppRouteImport } from './routes/_public/download-app'
import { Route as AuthUpdatePasswordRouteImport } from './routes/_auth/update-password'
import { Route as AuthSelectTenantRouteImport } from './routes/_auth/select-tenant'
import { Route as AuthRegisterOtpRouteImport } from './routes/_auth/register-otp'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthRecoveryPasswordRouteImport } from './routes/_auth/recovery-password'
import { Route as AuthPasswordResetRouteImport } from './routes/_auth/password-reset'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthAccessPermissionsRouteImport } from './routes/_auth/access-permissions'
import { Route as AppVehiclesRouteImport } from './routes/_app/vehicles'
import { Route as AppVehicleBookingsRouteImport } from './routes/_app/vehicle-bookings'
import { Route as AppUserGuideRouteImport } from './routes/_app/user-guide'
import { Route as AppUserAuditRouteImport } from './routes/_app/user-audit'
import { Route as AppUploadAttachmentsRouteImport } from './routes/_app/upload-attachments'
import { Route as AppUpdateAppRouteImport } from './routes/_app/update-app'
import { Route as AppTravelRouteImport } from './routes/_app/travel'
import { Route as AppTranslationsRouteImport } from './routes/_app/translations'
import { Route as AppTranslateStructureRouteImport } from './routes/_app/translate-structure'
import { Route as AppTicketsRouteImport } from './routes/_app/tickets'
import { Route as AppTestPlansRouteImport } from './routes/_app/test-plans'
import { Route as AppTestCoverageRouteImport } from './routes/_app/test-coverage'
import { Route as AppTestCasesRouteImport } from './routes/_app/test-cases'
import { Route as AppTeamDeadlinesRouteImport } from './routes/_app/team-deadlines'
import { Route as AppTeamCalendarRouteImport } from './routes/_app/team-calendar'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as AppSwitchTenantRouteImport } from './routes/_app/switch-tenant'
import { Route as AppSupportIntakeRouteImport } from './routes/_app/support-intake'
import { Route as AppSupportRouteImport } from './routes/_app/support'
import { Route as AppStatisticsRouteImport } from './routes/_app/statistics'
import { Route as AppSprintRouteImport } from './routes/_app/sprint'
import { Route as AppSmartWorkingRouteImport } from './routes/_app/smart-working'
import { Route as AppShiftSwapsRouteImport } from './routes/_app/shift-swaps'
import { Route as AppSetupRouteImport } from './routes/_app/setup'
import { Route as AppServiceReportsRouteImport } from './routes/_app/service-reports'
import { Route as AppReportingRouteImport } from './routes/_app/reporting'
import { Route as AppQualityRouteImport } from './routes/_app/quality'
import { Route as AppProjectForecastRouteImport } from './routes/_app/project-forecast'
import { Route as AppProductsRouteImport } from './routes/_app/products'
import { Route as AppPlanningRouteImport } from './routes/_app/planning'
import { Route as AppOpenAppRouteImport } from './routes/_app/open-app'
import { Route as AppOnboardingRouteImport } from './routes/_app/onboarding'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppNotesRouteImport } from './routes/_app/notes'
import { Route as AppMyViolationsRouteImport } from './routes/_app/my-violations'
import { Route as AppMyVehiclesRouteImport } from './routes/_app/my-vehicles'
import { Route as AppMySubscriptionsRouteImport } from './routes/_app/my-subscriptions'
import { Route as AppMediaRouteImport } from './routes/_app/media'
import { Route as AppMaeworldRouteImport } from './routes/_app/maeworld'
import { Route as AppLicensingRouteImport } from './routes/_app/licensing'
import { Route as AppLegalsRouteImport } from './routes/_app/legals'
import { Route as AppLegalNoticesRouteImport } from './routes/_app/legal-notices'
import { Route as AppLeaveRouteImport } from './routes/_app/leave'
import { Route as AppIntercompanyRouteImport } from './routes/_app/intercompany'
import { Route as AppInstrumentsCalendarRouteImport } from './routes/_app/instruments-calendar'
import { Route as AppInsightsRouteImport } from './routes/_app/insights'
import { Route as AppHelpRouteImport } from './routes/_app/help'
import { Route as AppGroupRulesRouteImport } from './routes/_app/group-rules'
import { Route as AppGeneralCrudRouteImport } from './routes/_app/general-crud'
import { Route as AppFleetRouteImport } from './routes/_app/fleet'
import { Route as AppExpenseReportsRouteImport } from './routes/_app/expense-reports'
import { Route as AppDeveloperGuideRouteImport } from './routes/_app/developer-guide'
import { Route as AppConfigurationRouteImport } from './routes/_app/configuration'
import { Route as AppChangelogRouteImport } from './routes/_app/changelog'
import { Route as AppCarHistoryRouteImport } from './routes/_app/car-history'
import { Route as AppBillingRouteImport } from './routes/_app/billing'
import { Route as AppAttendanceRouteImport } from './routes/_app/attendance'
import { Route as AppArticlesRouteImport } from './routes/_app/articles'
import { Route as AppApprovalsRouteImport } from './routes/_app/approvals'
import { Route as AppAppAndroidRouteImport } from './routes/_app/app-android'
import { Route as AppAboutRouteImport } from './routes/_app/about'
import { Route as AppWorkforceRouteRouteImport } from './routes/_app/workforce/route'
import { Route as AppWarehouseRouteRouteImport } from './routes/_app/warehouse/route'
import { Route as AppUsersRouteRouteImport } from './routes/_app/users/route'
import { Route as AppTimesheetRouteRouteImport } from './routes/_app/timesheet/route'
import { Route as AppTemplatesRouteRouteImport } from './routes/_app/templates/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppRolesRouteRouteImport } from './routes/_app/roles/route'
import { Route as AppProjectsRouteRouteImport } from './routes/_app/projects/route'
import { Route as PortalPortalIndexRouteImport } from './routes/_portal/portal/index'
import { Route as AppWorkforceIndexRouteImport } from './routes/_app/workforce/index'
import { Route as AppWarehouseIndexRouteImport } from './routes/_app/warehouse/index'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppTimesheetIndexRouteImport } from './routes/_app/timesheet/index'
import { Route as AppTestPlansIndexRouteImport } from './routes/_app/test-plans.index'
import { Route as AppTemplatesIndexRouteImport } from './routes/_app/templates/index'
import { Route as AppTasksIndexRouteImport } from './routes/_app/tasks.index'
import { Route as AppSmartWorkingIndexRouteImport } from './routes/_app/smart-working.index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppRolesIndexRouteImport } from './routes/_app/roles/index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppPlanningIndexRouteImport } from './routes/_app/planning.index'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders/index'
import { Route as AppNotificationsIndexRouteImport } from './routes/_app/notifications.index'
import { Route as AppLeaveIndexRouteImport } from './routes/_app/leave.index'
import { Route as AppInstrumentsCalendarIndexRouteImport } from './routes/_app/instruments-calendar.index'
import { Route as AppFoodcostIndexRouteImport } from './routes/_app/foodcost/index'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'
import { Route as AppCircularsIndexRouteImport } from './routes/_app/circulars.index'
import { Route as PublicTermsCodeRouteImport } from './routes/_public/terms.$code'
import { Route as PortalPortalVerbaliRouteImport } from './routes/_portal/portal/verbali'
import { Route as PortalPortalProfiloRouteImport } from './routes/_portal/portal/profilo'
import { Route as PortalPortalOrdiniRouteImport } from './routes/_portal/portal/ordini'
import { Route as PortalPortalNumeriRouteImport } from './routes/_portal/portal/numeri'
import { Route as PortalPortalFattureRouteImport } from './routes/_portal/portal/fatture'
import { Route as PortalPortalDocumentiRouteImport } from './routes/_portal/portal/documenti'
import { Route as PortalPortalCommesseRouteImport } from './routes/_portal/portal/commesse'
import { Route as PortalPortalCircularsRouteImport } from './routes/_portal/portal/circulars'
import { Route as PortalPortalAziendaRouteImport } from './routes/_portal/portal/azienda'
import { Route as PortalPortalAttivitaRouteImport } from './routes/_portal/portal/attivita'
import { Route as PortalPortalAssistenzaRouteImport } from './routes/_portal/portal/assistenza'
import { Route as PortalPortalModuloRouteImport } from './routes/_portal/portal/$modulo'
import { Route as AppWorkforceTrainingRouteImport } from './routes/_app/workforce/training'
import { Route as AppWorkforceTodayRouteImport } from './routes/_app/workforce/today'
import { Route as AppWorkforceSitePresencesRouteImport } from './routes/_app/workforce/site-presences'
import { Route as AppWorkforceRolesRouteImport } from './routes/_app/workforce/roles'
import { Route as AppWorkforceHierarchyRouteImport } from './routes/_app/workforce/hierarchy'
import { Route as AppWorkforceExternalRouteImport } from './routes/_app/workforce/external'
import { Route as AppWorkforceDashboardRouteImport } from './routes/_app/workforce/dashboard'
import { Route as AppWorkforceBuRouteImport } from './routes/_app/workforce/bu'
import { Route as AppWorkforceEmployeeIdRouteImport } from './routes/_app/workforce/$employeeId'
import { Route as AppWarehouseWarehousesRouteImport } from './routes/_app/warehouse/warehouses'
import { Route as AppWarehouseLotsRouteImport } from './routes/_app/warehouse/lots'
import { Route as AppWarehouseLocationsRouteImport } from './routes/_app/warehouse/locations'
import { Route as AppWarehouseItemsRouteImport } from './routes/_app/warehouse/items'
import { Route as AppWarehouseInventoryRouteImport } from './routes/_app/warehouse/inventory'
import { Route as AppWarehouseDocumentsRouteImport } from './routes/_app/warehouse/documents'
import { Route as AppWarehouseAttributesRouteImport } from './routes/_app/warehouse/attributes'
import { Route as AppUsersNewRouteImport } from './routes/_app/users/new'
import { Route as AppUsersUserIdRouteImport } from './routes/_app/users/$userId'
import { Route as AppTimesheetReasonsRouteImport } from './routes/_app/timesheet/reasons'
import { Route as AppTimesheetNewRouteImport } from './routes/_app/timesheet/new'
import { Route as AppTimesheetByProjectRouteImport } from './routes/_app/timesheet/by-project'
import { Route as AppTimesheetApprovalRouteImport } from './routes/_app/timesheet/approval'
import { Route as AppTimesheetAdminRouteImport } from './routes/_app/timesheet/admin'
import { Route as AppTestPlansPlanIdRouteImport } from './routes/_app/test-plans.$planId'
import { Route as AppTemplatesTemplateIdRouteImport } from './routes/_app/templates/$templateId'
import { Route as AppTasksWbsRouteImport } from './routes/_app/tasks.wbs'
import { Route as AppTasksPlanRouteImport } from './routes/_app/tasks.plan'
import { Route as AppTasksNotesRouteImport } from './routes/_app/tasks.notes'
import { Route as AppTasksNewRouteImport } from './routes/_app/tasks.new'
import { Route as AppTasksListRouteImport } from './routes/_app/tasks.list'
import { Route as AppTasksKanbanRouteImport } from './routes/_app/tasks.kanban'
import { Route as AppTasksGanttInteractiveRouteImport } from './routes/_app/tasks.gantt-interactive'
import { Route as AppTasksGanttRouteImport } from './routes/_app/tasks.gantt'
import { Route as AppTasksDashboardRouteImport } from './routes/_app/tasks.dashboard'
import { Route as AppTasksCardRouteImport } from './routes/_app/tasks.card'
import { Route as AppTasksCapacityRouteImport } from './routes/_app/tasks.capacity'
import { Route as AppTasksTaskIdRouteImport } from './routes/_app/tasks.$taskId'
import { Route as AppSmartWorkingApprovalsRouteImport } from './routes/_app/smart-working.approvals'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as AppSettingsProtectedDataRouteImport } from './routes/_app/settings/protected-data'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings/profile'
import { Route as AppSettingsPrivacyRouteImport } from './routes/_app/settings/privacy'
import { Route as AppSettingsPreferencesRouteImport } from './routes/_app/settings/preferences'
import { Route as AppSettingsNotificationPreferencesRouteImport } from './routes/_app/settings/notification-preferences'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/settings/integrations'
import { Route as AppSettingsDevicesRouteImport } from './routes/_app/settings/devices'
import { Route as AppSettingsApiKeysRouteImport } from './routes/_app/settings/api-keys'
import { Route as AppSecretaryAreaRouteImport } from './routes/_app/secretary.area'
import { Route as AppRolesRoleIdRouteImport } from './routes/_app/roles/$roleId'
import { Route as AppProjectsWbsRouteImport } from './routes/_app/projects/wbs'
import { Route as AppProjectsNewRouteImport } from './routes/_app/projects/new'
import { Route as AppProjectsGanttRouteImport } from './routes/_app/projects/gantt'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects/$projectId'
import { Route as AppPlanningNewRouteImport } from './routes/_app/planning.new'
import { Route as AppOrganizationWorkShiftsRouteImport } from './routes/_app/organization/work-shifts'
import { Route as AppOrganizationWorkRulesRouteImport } from './routes/_app/organization/work-rules'
import { Route as AppOrganizationPermissionsRouteImport } from './routes/_app/organization/permissions'
import { Route as AppOrganizationEmployeesRouteImport } from './routes/_app/organization/employees'
import { Route as AppOrganizationCompanyDataRouteImport } from './routes/_app/organization/company-data'
import { Route as AppOrganizationCompanyRouteImport } from './routes/_app/organization/company'
import { Route as AppOrdersOrderIdRouteImport } from './routes/_app/orders/$orderId'
import { Route as AppNotificationsNotificationIdRouteImport } from './routes/_app/notifications.$notificationId'
import { Route as AppMcpAuthorizeRouteImport } from './routes/_app/mcp/authorize'
import { Route as AppLeaveNewRouteImport } from './routes/_app/leave.new'
import { Route as AppLeaveApprovalsRouteImport } from './routes/_app/leave.approvals'
import { Route as AppInstrumentsCalendarApprovalsRouteImport } from './routes/_app/instruments-calendar.approvals'
import { Route as AppInsightsSubscriptionsRouteImport } from './routes/_app/insights.subscriptions'
import { Route as AppInsightsMonthlyInvoicesRouteImport } from './routes/_app/insights.monthly-invoices'
import { Route as AppFoodcostSollecitiRouteImport } from './routes/_app/foodcost/solleciti'
import { Route as AppFoodcostSchemaRouteImport } from './routes/_app/foodcost/schema'
import { Route as AppFoodcostMappatureRouteImport } from './routes/_app/foodcost/mappature'
import { Route as AppFoodcostIndicatoriRouteImport } from './routes/_app/foodcost/indicatori'
import { Route as AppFoodcostClusterRouteImport } from './routes/_app/foodcost/cluster'
import { Route as AppFoodcostPeriodoIdRouteImport } from './routes/_app/foodcost/$periodoId'
import { Route as AppClientsClientIdRouteImport } from './routes/_app/clients/$clientId'
import { Route as AppCircularsReleaseNotesRouteImport } from './routes/_app/circulars.release-notes'
import { Route as AppCircularsRegisterRouteImport } from './routes/_app/circulars.register'
import { Route as AppBookingsNewRouteImport } from './routes/_app/bookings/new'
import { Route as AppBookingsCarHistoryRouteImport } from './routes/_app/bookings/car-history'
import { Route as AppAttendanceTeamMonthRouteImport } from './routes/_app/attendance_.team-month'
import { Route as AppArticlesIdRouteImport } from './routes/_app/articles_.$id'
import { Route as AppAdminWorkflowsRouteImport } from './routes/_app/admin/workflows'
import { Route as AppAdminTravelPoliciesRouteImport } from './routes/_app/admin/travel-policies'
import { Route as AppAdminTranslateStructureRouteImport } from './routes/_app/admin.translate-structure'
import { Route as AppAdminTenantUsersRouteImport } from './routes/_app/admin/tenant-users'
import { Route as AppAdminTenantManagementRouteImport } from './routes/_app/admin/tenant-management'
import { Route as AppAdminTenantAttributesRouteImport } from './routes/_app/admin/tenant-attributes'
import { Route as AppAdminTaskRulesRouteImport } from './routes/_app/admin/task-rules'
import { Route as AppAdminTaskLabelsRouteImport } from './routes/_app/admin/task-labels'
import { Route as AppAdminTardinessPoliciesRouteImport } from './routes/_app/admin/tardiness-policies'
import { Route as AppAdminSystemRouteImport } from './routes/_app/admin.system'
import { Route as AppAdminSupportTopicsRouteImport } from './routes/_app/admin/support-topics'
import { Route as AppAdminSubscriptionTypesRouteImport } from './routes/_app/admin/subscription-types'
import { Route as AppAdminStructureLabelsRouteImport } from './routes/_app/admin/structure-labels'
import { Route as AppAdminSmartWorkingConfigRouteImport } from './routes/_app/admin/smart-working-config'
import { Route as AppAdminSendCommunicationsRouteImport } from './routes/_app/admin.send-communications'
import { Route as AppAdminProtectedStatusesRouteImport } from './routes/_app/admin/protected-statuses'
import { Route as AppAdminProjectTypePresetsRouteImport } from './routes/_app/admin/project-type-presets'
import { Route as AppAdminProjectCategoriesRouteImport } from './routes/_app/admin/project-categories'
import { Route as AppAdminProjectAttributeDefinitionsRouteImport } from './routes/_app/admin/project-attribute-definitions'
import { Route as AppAdminPortalPagesRouteImport } from './routes/_app/admin/portal-pages'
import { Route as AppAdminPortalDocumentsRouteImport } from './routes/_app/admin/portal-documents'
import { Route as AppAdminPoliciesRouteImport } from './routes/_app/admin/policies'
import { Route as AppAdminPlanningPoliciesRouteImport } from './routes/_app/admin/planning-policies'
import { Route as AppAdminModulesRouteImport } from './routes/_app/admin/modules'
import { Route as AppAdminMileageRatesRouteImport } from './routes/_app/admin/mileage-rates'
import { Route as AppAdminMcpConnectionsRouteImport } from './routes/_app/admin/mcp-connections'
import { Route as AppAdminMaintenanceRouteImport } from './routes/_app/admin/maintenance'
import { Route as AppAdminLogsRouteImport } from './routes/_app/admin/logs'
import { Route as AppAdminLicensesCatalogRouteImport } from './routes/_app/admin/licenses-catalog'
import { Route as AppAdminLicensePlansRouteImport } from './routes/_app/admin/license-plans'
import { Route as AppAdminLicenseDashboardRouteImport } from './routes/_app/admin.license-dashboard'
import { Route as AppAdminLeaveConfigRouteImport } from './routes/_app/admin/leave-config'
import { Route as AppAdminJobsRouteImport } from './routes/_app/admin/jobs'
import { Route as AppAdminEmailLogRouteImport } from './routes/_app/admin/email-log'
import { Route as AppAdminCrossTenantAccessLogsRouteImport } from './routes/_app/admin.cross-tenant-access-logs'
import { Route as AppAdminConnectorsRouteImport } from './routes/_app/admin/connectors'
import { Route as AppAdminClientIntakeRouteImport } from './routes/_app/admin/client-intake'
import { Route as AppAdminCategoriesRouteImport } from './routes/_app/admin.categories'
import { Route as AppAdminBrandingRouteImport } from './routes/_app/admin/branding'
import { Route as AppAdminBoardConfigRouteImport } from './routes/_app/admin/board-config'
import { Route as AppAdminAuditLogRouteImport } from './routes/_app/admin/audit-log'
import { Route as AppAdminAttendanceSourcesRouteImport } from './routes/_app/admin/attendance-sources'
import { Route as AppAdminAttendanceRemindersRouteImport } from './routes/_app/admin/attendance-reminders'
import { Route as AppWorkforceSitesIndexRouteImport } from './routes/_app/workforce/sites/index'
import { Route as AppAdminTenantsIndexRouteImport } from './routes/_app/admin/tenants/index'
import { Route as AppWorkforceSitesSiteIdRouteImport } from './routes/_app/workforce/sites/$siteId'
import { Route as AppProjectsProjectIdDashboardRouteImport } from './routes/_app/projects/$projectId.dashboard'
import { Route as AppFoodcostSchedaPeriodoIdRouteImport } from './routes/_app/foodcost/scheda/$periodoId'
import { Route as AppFoodcostPortaleClienteIdRouteImport } from './routes/_app/foodcost/portale/$clienteId'
import { Route as AppAdminTenantsGroupRouteImport } from './routes/_app/admin/tenants/group'
import { Route as AppAdminTenantsTenantIdRouteImport } from './routes/_app/admin/tenants/$tenantId'
import { Route as AppAdminTenantsTenantIdSubscriptionRouteImport } from './routes/_app/admin/tenants/$tenantId.subscription'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/_portal',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const PublicTenantFallbackRoute = PublicTenantFallbackRouteImport.update({
  id: '/tenant-fallback',
  path: '/tenant-fallback',
  getParentRoute: () => PublicRoute,
} as any)
const PublicMaintenanceRoute = PublicMaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => PublicRoute,
} as any)
const PublicHelpDeskUnlogRoute = PublicHelpDeskUnlogRouteImport.update({
  id: '/help-desk-unlog',
  path: '/help-desk-unlog',
  getParentRoute: () => PublicRoute,
} as any)
const PublicDownloadAppRoute = PublicDownloadAppRouteImport.update({
  id: '/download-app',
  path: '/download-app',
  getParentRoute: () => PublicRoute,
} as any)
const AuthUpdatePasswordRoute = AuthUpdatePasswordRouteImport.update({
  id: '/update-password',
  path: '/update-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSelectTenantRoute = AuthSelectTenantRouteImport.update({
  id: '/select-tenant',
  path: '/select-tenant',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterOtpRoute = AuthRegisterOtpRouteImport.update({
  id: '/register-otp',
  path: '/register-otp',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecoveryPasswordRoute = AuthRecoveryPasswordRouteImport.update({
  id: '/recovery-password',
  path: '/recovery-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPasswordResetRoute = AuthPasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccessPermissionsRoute = AuthAccessPermissionsRouteImport.update({
  id: '/access-permissions',
  path: '/access-permissions',
  getParentRoute: () => AuthRoute,
} as any)
const AppVehiclesRoute = AppVehiclesRouteImport.update({
  id: '/vehicles',
  path: '/vehicles',
  getParentRoute: () => AppRoute,
} as any)
const AppVehicleBookingsRoute = AppVehicleBookingsRouteImport.update({
  id: '/vehicle-bookings',
  path: '/vehicle-bookings',
  getParentRoute: () => AppRoute,
} as any)
const AppUserGuideRoute = AppUserGuideRouteImport.update({
  id: '/user-guide',
  path: '/user-guide',
  getParentRoute: () => AppRoute,
} as any)
const AppUserAuditRoute = AppUserAuditRouteImport.update({
  id: '/user-audit',
  path: '/user-audit',
  getParentRoute: () => AppRoute,
} as any)
const AppUploadAttachmentsRoute = AppUploadAttachmentsRouteImport.update({
  id: '/upload-attachments',
  path: '/upload-attachments',
  getParentRoute: () => AppRoute,
} as any)
const AppUpdateAppRoute = AppUpdateAppRouteImport.update({
  id: '/update-app',
  path: '/update-app',
  getParentRoute: () => AppRoute,
} as any)
const AppTravelRoute = AppTravelRouteImport.update({
  id: '/travel',
  path: '/travel',
  getParentRoute: () => AppRoute,
} as any)
const AppTranslationsRoute = AppTranslationsRouteImport.update({
  id: '/translations',
  path: '/translations',
  getParentRoute: () => AppRoute,
} as any)
const AppTranslateStructureRoute = AppTranslateStructureRouteImport.update({
  id: '/translate-structure',
  path: '/translate-structure',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketsRoute = AppTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AppRoute,
} as any)
const AppTestPlansRoute = AppTestPlansRouteImport.update({
  id: '/test-plans',
  path: '/test-plans',
  getParentRoute: () => AppRoute,
} as any)
const AppTestCoverageRoute = AppTestCoverageRouteImport.update({
  id: '/test-coverage',
  path: '/test-coverage',
  getParentRoute: () => AppRoute,
} as any)
const AppTestCasesRoute = AppTestCasesRouteImport.update({
  id: '/test-cases',
  path: '/test-cases',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamDeadlinesRoute = AppTeamDeadlinesRouteImport.update({
  id: '/team-deadlines',
  path: '/team-deadlines',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamCalendarRoute = AppTeamCalendarRouteImport.update({
  id: '/team-calendar',
  path: '/team-calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppSwitchTenantRoute = AppSwitchTenantRouteImport.update({
  id: '/switch-tenant',
  path: '/switch-tenant',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportIntakeRoute = AppSupportIntakeRouteImport.update({
  id: '/support-intake',
  path: '/support-intake',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportRoute = AppSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AppRoute,
} as any)
const AppStatisticsRoute = AppStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AppRoute,
} as any)
const AppSprintRoute = AppSprintRouteImport.update({
  id: '/sprint',
  path: '/sprint',
  getParentRoute: () => AppRoute,
} as any)
const AppSmartWorkingRoute = AppSmartWorkingRouteImport.update({
  id: '/smart-working',
  path: '/smart-working',
  getParentRoute: () => AppRoute,
} as any)
const AppShiftSwapsRoute = AppShiftSwapsRouteImport.update({
  id: '/shift-swaps',
  path: '/shift-swaps',
  getParentRoute: () => AppRoute,
} as any)
const AppSetupRoute = AppSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppServiceReportsRoute = AppServiceReportsRouteImport.update({
  id: '/service-reports',
  path: '/service-reports',
  getParentRoute: () => AppRoute,
} as any)
const AppReportingRoute = AppReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => AppRoute,
} as any)
const AppQualityRoute = AppQualityRouteImport.update({
  id: '/quality',
  path: '/quality',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectForecastRoute = AppProjectForecastRouteImport.update({
  id: '/project-forecast',
  path: '/project-forecast',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsRoute = AppProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanningRoute = AppPlanningRouteImport.update({
  id: '/planning',
  path: '/planning',
  getParentRoute: () => AppRoute,
} as any)
const AppOpenAppRoute = AppOpenAppRouteImport.update({
  id: '/open-app',
  path: '/open-app',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppNotesRoute = AppNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => AppRoute,
} as any)
const AppMyViolationsRoute = AppMyViolationsRouteImport.update({
  id: '/my-violations',
  path: '/my-violations',
  getParentRoute: () => AppRoute,
} as any)
const AppMyVehiclesRoute = AppMyVehiclesRouteImport.update({
  id: '/my-vehicles',
  path: '/my-vehicles',
  getParentRoute: () => AppRoute,
} as any)
const AppMySubscriptionsRoute = AppMySubscriptionsRouteImport.update({
  id: '/my-subscriptions',
  path: '/my-subscriptions',
  getParentRoute: () => AppRoute,
} as any)
const AppMediaRoute = AppMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AppRoute,
} as any)
const AppMaeworldRoute = AppMaeworldRouteImport.update({
  id: '/maeworld',
  path: '/maeworld',
  getParentRoute: () => AppRoute,
} as any)
const AppLicensingRoute = AppLicensingRouteImport.update({
  id: '/licensing',
  path: '/licensing',
  getParentRoute: () => AppRoute,
} as any)
const AppLegalsRoute = AppLegalsRouteImport.update({
  id: '/legals',
  path: '/legals',
  getParentRoute: () => AppRoute,
} as any)
const AppLegalNoticesRoute = AppLegalNoticesRouteImport.update({
  id: '/legal-notices',
  path: '/legal-notices',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaveRoute = AppLeaveRouteImport.update({
  id: '/leave',
  path: '/leave',
  getParentRoute: () => AppRoute,
} as any)
const AppIntercompanyRoute = AppIntercompanyRouteImport.update({
  id: '/intercompany',
  path: '/intercompany',
  getParentRoute: () => AppRoute,
} as any)
const AppInstrumentsCalendarRoute = AppInstrumentsCalendarRouteImport.update({
  id: '/instruments-calendar',
  path: '/instruments-calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsRoute = AppInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupRulesRoute = AppGroupRulesRouteImport.update({
  id: '/group-rules',
  path: '/group-rules',
  getParentRoute: () => AppRoute,
} as any)
const AppGeneralCrudRoute = AppGeneralCrudRouteImport.update({
  id: '/general-crud',
  path: '/general-crud',
  getParentRoute: () => AppRoute,
} as any)
const AppFleetRoute = AppFleetRouteImport.update({
  id: '/fleet',
  path: '/fleet',
  getParentRoute: () => AppRoute,
} as any)
const AppExpenseReportsRoute = AppExpenseReportsRouteImport.update({
  id: '/expense-reports',
  path: '/expense-reports',
  getParentRoute: () => AppRoute,
} as any)
const AppDeveloperGuideRoute = AppDeveloperGuideRouteImport.update({
  id: '/developer-guide',
  path: '/developer-guide',
  getParentRoute: () => AppRoute,
} as any)
const AppConfigurationRoute = AppConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => AppRoute,
} as any)
const AppChangelogRoute = AppChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => AppRoute,
} as any)
const AppCarHistoryRoute = AppCarHistoryRouteImport.update({
  id: '/car-history',
  path: '/car-history',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppAttendanceRoute = AppAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AppRoute,
} as any)
const AppArticlesRoute = AppArticlesRouteImport.update({
  id: '/articles',
  path: '/articles',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRoute = AppApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppAppAndroidRoute = AppAppAndroidRouteImport.update({
  id: '/app-android',
  path: '/app-android',
  getParentRoute: () => AppRoute,
} as any)
const AppAboutRoute = AppAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkforceRouteRoute = AppWorkforceRouteRouteImport.update({
  id: '/workforce',
  path: '/workforce',
  getParentRoute: () => AppRoute,
} as any)
const AppWarehouseRouteRoute = AppWarehouseRouteRouteImport.update({
  id: '/warehouse',
  path: '/warehouse',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRouteRoute = AppUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppTimesheetRouteRoute = AppTimesheetRouteRouteImport.update({
  id: '/timesheet',
  path: '/timesheet',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplatesRouteRoute = AppTemplatesRouteRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppRolesRouteRoute = AppRolesRouteRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsRouteRoute = AppProjectsRouteRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRoute,
} as any)
const PortalPortalIndexRoute = PortalPortalIndexRouteImport.update({
  id: '/portal/',
  path: '/portal/',
  getParentRoute: () => PortalRoute,
} as any)
const AppWorkforceIndexRoute = AppWorkforceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWarehouseIndexRoute = AppWarehouseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWarehouseRouteRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppTimesheetIndexRoute = AppTimesheetIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTimesheetRouteRoute,
} as any)
const AppTestPlansIndexRoute = AppTestPlansIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTestPlansRoute,
} as any)
const AppTemplatesIndexRoute = AppTemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTemplatesRouteRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppSmartWorkingIndexRoute = AppSmartWorkingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSmartWorkingRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppRolesIndexRoute = AppRolesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRolesRouteRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppPlanningIndexRoute = AppPlanningIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPlanningRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsIndexRoute = AppNotificationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppNotificationsRoute,
} as any)
const AppLeaveIndexRoute = AppLeaveIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLeaveRoute,
} as any)
const AppInstrumentsCalendarIndexRoute =
  AppInstrumentsCalendarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppInstrumentsCalendarRoute,
  } as any)
const AppFoodcostIndexRoute = AppFoodcostIndexRouteImport.update({
  id: '/foodcost/',
  path: '/foodcost/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppCircularsIndexRoute = AppCircularsIndexRouteImport.update({
  id: '/circulars/',
  path: '/circulars/',
  getParentRoute: () => AppRoute,
} as any)
const PublicTermsCodeRoute = PublicTermsCodeRouteImport.update({
  id: '/terms/$code',
  path: '/terms/$code',
  getParentRoute: () => PublicRoute,
} as any)
const PortalPortalVerbaliRoute = PortalPortalVerbaliRouteImport.update({
  id: '/portal/verbali',
  path: '/portal/verbali',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalProfiloRoute = PortalPortalProfiloRouteImport.update({
  id: '/portal/profilo',
  path: '/portal/profilo',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalOrdiniRoute = PortalPortalOrdiniRouteImport.update({
  id: '/portal/ordini',
  path: '/portal/ordini',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalNumeriRoute = PortalPortalNumeriRouteImport.update({
  id: '/portal/numeri',
  path: '/portal/numeri',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalFattureRoute = PortalPortalFattureRouteImport.update({
  id: '/portal/fatture',
  path: '/portal/fatture',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalDocumentiRoute = PortalPortalDocumentiRouteImport.update({
  id: '/portal/documenti',
  path: '/portal/documenti',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalCommesseRoute = PortalPortalCommesseRouteImport.update({
  id: '/portal/commesse',
  path: '/portal/commesse',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalCircularsRoute = PortalPortalCircularsRouteImport.update({
  id: '/portal/circulars',
  path: '/portal/circulars',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalAziendaRoute = PortalPortalAziendaRouteImport.update({
  id: '/portal/azienda',
  path: '/portal/azienda',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalAttivitaRoute = PortalPortalAttivitaRouteImport.update({
  id: '/portal/attivita',
  path: '/portal/attivita',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalAssistenzaRoute = PortalPortalAssistenzaRouteImport.update({
  id: '/portal/assistenza',
  path: '/portal/assistenza',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPortalModuloRoute = PortalPortalModuloRouteImport.update({
  id: '/portal/$modulo',
  path: '/portal/$modulo',
  getParentRoute: () => PortalRoute,
} as any)
const AppWorkforceTrainingRoute = AppWorkforceTrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceTodayRoute = AppWorkforceTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceSitePresencesRoute =
  AppWorkforceSitePresencesRouteImport.update({
    id: '/site-presences',
    path: '/site-presences',
    getParentRoute: () => AppWorkforceRouteRoute,
  } as any)
const AppWorkforceRolesRoute = AppWorkforceRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceHierarchyRoute = AppWorkforceHierarchyRouteImport.update({
  id: '/hierarchy',
  path: '/hierarchy',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceExternalRoute = AppWorkforceExternalRouteImport.update({
  id: '/external',
  path: '/external',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceDashboardRoute = AppWorkforceDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceBuRoute = AppWorkforceBuRouteImport.update({
  id: '/bu',
  path: '/bu',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceEmployeeIdRoute = AppWorkforceEmployeeIdRouteImport.update({
  id: '/$employeeId',
  path: '/$employeeId',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWarehouseWarehousesRoute = AppWarehouseWarehousesRouteImport.update({
  id: '/warehouses',
  path: '/warehouses',
  getParentRoute: () => AppWarehouseRouteRoute,
} as any)
const AppWarehouseLotsRoute = AppWarehouseLotsRouteImport.update({
  id: '/lots',
  path: '/lots',
  getParentRoute: () => AppWarehouseRouteRoute,
} as any)
const AppWarehouseLocationsRoute = AppWarehouseLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => AppWarehouseRouteRoute,
} as any)
const AppWarehouseItemsRoute = AppWarehouseItemsRouteImport.update({
  id: '/items',
  path: '/items',
  getParentRoute: () => AppWarehouseRouteRoute,
} as any)
const AppWarehouseInventoryRoute = AppWarehouseInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppWarehouseRouteRoute,
} as any)
const AppWarehouseDocumentsRoute = AppWarehouseDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppWarehouseRouteRoute,
} as any)
const AppWarehouseAttributesRoute = AppWarehouseAttributesRouteImport.update({
  id: '/attributes',
  path: '/attributes',
  getParentRoute: () => AppWarehouseRouteRoute,
} as any)
const AppUsersNewRoute = AppUsersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersUserIdRoute = AppUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppTimesheetReasonsRoute = AppTimesheetReasonsRouteImport.update({
  id: '/reasons',
  path: '/reasons',
  getParentRoute: () => AppTimesheetRouteRoute,
} as any)
const AppTimesheetNewRoute = AppTimesheetNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppTimesheetRouteRoute,
} as any)
const AppTimesheetByProjectRoute = AppTimesheetByProjectRouteImport.update({
  id: '/by-project',
  path: '/by-project',
  getParentRoute: () => AppTimesheetRouteRoute,
} as any)
const AppTimesheetApprovalRoute = AppTimesheetApprovalRouteImport.update({
  id: '/approval',
  path: '/approval',
  getParentRoute: () => AppTimesheetRouteRoute,
} as any)
const AppTimesheetAdminRoute = AppTimesheetAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppTimesheetRouteRoute,
} as any)
const AppTestPlansPlanIdRoute = AppTestPlansPlanIdRouteImport.update({
  id: '/$planId',
  path: '/$planId',
  getParentRoute: () => AppTestPlansRoute,
} as any)
const AppTemplatesTemplateIdRoute = AppTemplatesTemplateIdRouteImport.update({
  id: '/$templateId',
  path: '/$templateId',
  getParentRoute: () => AppTemplatesRouteRoute,
} as any)
const AppTasksWbsRoute = AppTasksWbsRouteImport.update({
  id: '/wbs',
  path: '/wbs',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksPlanRoute = AppTasksPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksNotesRoute = AppTasksNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksNewRoute = AppTasksNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksListRoute = AppTasksListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksKanbanRoute = AppTasksKanbanRouteImport.update({
  id: '/kanban',
  path: '/kanban',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksGanttInteractiveRoute =
  AppTasksGanttInteractiveRouteImport.update({
    id: '/gantt-interactive',
    path: '/gantt-interactive',
    getParentRoute: () => AppTasksRoute,
  } as any)
const AppTasksGanttRoute = AppTasksGanttRouteImport.update({
  id: '/gantt',
  path: '/gantt',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksDashboardRoute = AppTasksDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksCardRoute = AppTasksCardRouteImport.update({
  id: '/card',
  path: '/card',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksCapacityRoute = AppTasksCapacityRouteImport.update({
  id: '/capacity',
  path: '/capacity',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksTaskIdRoute = AppTasksTaskIdRouteImport.update({
  id: '/$taskId',
  path: '/$taskId',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppSmartWorkingApprovalsRoute =
  AppSmartWorkingApprovalsRouteImport.update({
    id: '/approvals',
    path: '/approvals',
    getParentRoute: () => AppSmartWorkingRoute,
  } as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsProtectedDataRoute =
  AppSettingsProtectedDataRouteImport.update({
    id: '/protected-data',
    path: '/protected-data',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPrivacyRoute = AppSettingsPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPreferencesRoute = AppSettingsPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsNotificationPreferencesRoute =
  AppSettingsNotificationPreferencesRouteImport.update({
    id: '/notification-preferences',
    path: '/notification-preferences',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDevicesRoute = AppSettingsDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsApiKeysRoute = AppSettingsApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSecretaryAreaRoute = AppSecretaryAreaRouteImport.update({
  id: '/secretary/area',
  path: '/secretary/area',
  getParentRoute: () => AppRoute,
} as any)
const AppRolesRoleIdRoute = AppRolesRoleIdRouteImport.update({
  id: '/$roleId',
  path: '/$roleId',
  getParentRoute: () => AppRolesRouteRoute,
} as any)
const AppProjectsWbsRoute = AppProjectsWbsRouteImport.update({
  id: '/wbs',
  path: '/wbs',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppProjectsNewRoute = AppProjectsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppProjectsGanttRoute = AppProjectsGanttRouteImport.update({
  id: '/gantt',
  path: '/gantt',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppPlanningNewRoute = AppPlanningNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppPlanningRoute,
} as any)
const AppOrganizationWorkShiftsRoute =
  AppOrganizationWorkShiftsRouteImport.update({
    id: '/organization/work-shifts',
    path: '/organization/work-shifts',
    getParentRoute: () => AppRoute,
  } as any)
const AppOrganizationWorkRulesRoute =
  AppOrganizationWorkRulesRouteImport.update({
    id: '/organization/work-rules',
    path: '/organization/work-rules',
    getParentRoute: () => AppRoute,
  } as any)
const AppOrganizationPermissionsRoute =
  AppOrganizationPermissionsRouteImport.update({
    id: '/organization/permissions',
    path: '/organization/permissions',
    getParentRoute: () => AppRoute,
  } as any)
const AppOrganizationEmployeesRoute =
  AppOrganizationEmployeesRouteImport.update({
    id: '/organization/employees',
    path: '/organization/employees',
    getParentRoute: () => AppRoute,
  } as any)
const AppOrganizationCompanyDataRoute =
  AppOrganizationCompanyDataRouteImport.update({
    id: '/organization/company-data',
    path: '/organization/company-data',
    getParentRoute: () => AppRoute,
  } as any)
const AppOrganizationCompanyRoute = AppOrganizationCompanyRouteImport.update({
  id: '/organization/company',
  path: '/organization/company',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersOrderIdRoute = AppOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsNotificationIdRoute =
  AppNotificationsNotificationIdRouteImport.update({
    id: '/$notificationId',
    path: '/$notificationId',
    getParentRoute: () => AppNotificationsRoute,
  } as any)
const AppMcpAuthorizeRoute = AppMcpAuthorizeRouteImport.update({
  id: '/mcp/authorize',
  path: '/mcp/authorize',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaveNewRoute = AppLeaveNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppLeaveRoute,
} as any)
const AppLeaveApprovalsRoute = AppLeaveApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppLeaveRoute,
} as any)
const AppInstrumentsCalendarApprovalsRoute =
  AppInstrumentsCalendarApprovalsRouteImport.update({
    id: '/approvals',
    path: '/approvals',
    getParentRoute: () => AppInstrumentsCalendarRoute,
  } as any)
const AppInsightsSubscriptionsRoute =
  AppInsightsSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AppInsightsRoute,
  } as any)
const AppInsightsMonthlyInvoicesRoute =
  AppInsightsMonthlyInvoicesRouteImport.update({
    id: '/monthly-invoices',
    path: '/monthly-invoices',
    getParentRoute: () => AppInsightsRoute,
  } as any)
const AppFoodcostSollecitiRoute = AppFoodcostSollecitiRouteImport.update({
  id: '/foodcost/solleciti',
  path: '/foodcost/solleciti',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodcostSchemaRoute = AppFoodcostSchemaRouteImport.update({
  id: '/foodcost/schema',
  path: '/foodcost/schema',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodcostMappatureRoute = AppFoodcostMappatureRouteImport.update({
  id: '/foodcost/mappature',
  path: '/foodcost/mappature',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodcostIndicatoriRoute = AppFoodcostIndicatoriRouteImport.update({
  id: '/foodcost/indicatori',
  path: '/foodcost/indicatori',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodcostClusterRoute = AppFoodcostClusterRouteImport.update({
  id: '/foodcost/cluster',
  path: '/foodcost/cluster',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodcostPeriodoIdRoute = AppFoodcostPeriodoIdRouteImport.update({
  id: '/foodcost/$periodoId',
  path: '/foodcost/$periodoId',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const AppCircularsReleaseNotesRoute =
  AppCircularsReleaseNotesRouteImport.update({
    id: '/circulars/release-notes',
    path: '/circulars/release-notes',
    getParentRoute: () => AppRoute,
  } as any)
const AppCircularsRegisterRoute = AppCircularsRegisterRouteImport.update({
  id: '/circulars/register',
  path: '/circulars/register',
  getParentRoute: () => AppRoute,
} as any)
const AppBookingsNewRoute = AppBookingsNewRouteImport.update({
  id: '/bookings/new',
  path: '/bookings/new',
  getParentRoute: () => AppRoute,
} as any)
const AppBookingsCarHistoryRoute = AppBookingsCarHistoryRouteImport.update({
  id: '/bookings/car-history',
  path: '/bookings/car-history',
  getParentRoute: () => AppRoute,
} as any)
const AppAttendanceTeamMonthRoute = AppAttendanceTeamMonthRouteImport.update({
  id: '/attendance_/team-month',
  path: '/attendance/team-month',
  getParentRoute: () => AppRoute,
} as any)
const AppArticlesIdRoute = AppArticlesIdRouteImport.update({
  id: '/articles_/$id',
  path: '/articles/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminWorkflowsRoute = AppAdminWorkflowsRouteImport.update({
  id: '/admin/workflows',
  path: '/admin/workflows',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTravelPoliciesRoute = AppAdminTravelPoliciesRouteImport.update({
  id: '/admin/travel-policies',
  path: '/admin/travel-policies',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTranslateStructureRoute =
  AppAdminTranslateStructureRouteImport.update({
    id: '/admin/translate-structure',
    path: '/admin/translate-structure',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminTenantUsersRoute = AppAdminTenantUsersRouteImport.update({
  id: '/admin/tenant-users',
  path: '/admin/tenant-users',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTenantManagementRoute =
  AppAdminTenantManagementRouteImport.update({
    id: '/admin/tenant-management',
    path: '/admin/tenant-management',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminTenantAttributesRoute =
  AppAdminTenantAttributesRouteImport.update({
    id: '/admin/tenant-attributes',
    path: '/admin/tenant-attributes',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminTaskRulesRoute = AppAdminTaskRulesRouteImport.update({
  id: '/admin/task-rules',
  path: '/admin/task-rules',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTaskLabelsRoute = AppAdminTaskLabelsRouteImport.update({
  id: '/admin/task-labels',
  path: '/admin/task-labels',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTardinessPoliciesRoute =
  AppAdminTardinessPoliciesRouteImport.update({
    id: '/admin/tardiness-policies',
    path: '/admin/tardiness-policies',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminSystemRoute = AppAdminSystemRouteImport.update({
  id: '/admin/system',
  path: '/admin/system',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSupportTopicsRoute = AppAdminSupportTopicsRouteImport.update({
  id: '/admin/support-topics',
  path: '/admin/support-topics',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSubscriptionTypesRoute =
  AppAdminSubscriptionTypesRouteImport.update({
    id: '/admin/subscription-types',
    path: '/admin/subscription-types',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminStructureLabelsRoute = AppAdminStructureLabelsRouteImport.update({
  id: '/admin/structure-labels',
  path: '/admin/structure-labels',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSmartWorkingConfigRoute =
  AppAdminSmartWorkingConfigRouteImport.update({
    id: '/admin/smart-working-config',
    path: '/admin/smart-working-config',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminSendCommunicationsRoute =
  AppAdminSendCommunicationsRouteImport.update({
    id: '/admin/send-communications',
    path: '/admin/send-communications',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminProtectedStatusesRoute =
  AppAdminProtectedStatusesRouteImport.update({
    id: '/admin/protected-statuses',
    path: '/admin/protected-statuses',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminProjectTypePresetsRoute =
  AppAdminProjectTypePresetsRouteImport.update({
    id: '/admin/project-type-presets',
    path: '/admin/project-type-presets',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminProjectCategoriesRoute =
  AppAdminProjectCategoriesRouteImport.update({
    id: '/admin/project-categories',
    path: '/admin/project-categories',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminProjectAttributeDefinitionsRoute =
  AppAdminProjectAttributeDefinitionsRouteImport.update({
    id: '/admin/project-attribute-definitions',
    path: '/admin/project-attribute-definitions',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminPortalPagesRoute = AppAdminPortalPagesRouteImport.update({
  id: '/admin/portal-pages',
  path: '/admin/portal-pages',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminPortalDocumentsRoute = AppAdminPortalDocumentsRouteImport.update({
  id: '/admin/portal-documents',
  path: '/admin/portal-documents',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminPoliciesRoute = AppAdminPoliciesRouteImport.update({
  id: '/admin/policies',
  path: '/admin/policies',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminPlanningPoliciesRoute =
  AppAdminPlanningPoliciesRouteImport.update({
    id: '/admin/planning-policies',
    path: '/admin/planning-policies',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminModulesRoute = AppAdminModulesRouteImport.update({
  id: '/admin/modules',
  path: '/admin/modules',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminMileageRatesRoute = AppAdminMileageRatesRouteImport.update({
  id: '/admin/mileage-rates',
  path: '/admin/mileage-rates',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminMcpConnectionsRoute = AppAdminMcpConnectionsRouteImport.update({
  id: '/admin/mcp-connections',
  path: '/admin/mcp-connections',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminMaintenanceRoute = AppAdminMaintenanceRouteImport.update({
  id: '/admin/maintenance',
  path: '/admin/maintenance',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminLogsRoute = AppAdminLogsRouteImport.update({
  id: '/admin/logs',
  path: '/admin/logs',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminLicensesCatalogRoute = AppAdminLicensesCatalogRouteImport.update({
  id: '/admin/licenses-catalog',
  path: '/admin/licenses-catalog',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminLicensePlansRoute = AppAdminLicensePlansRouteImport.update({
  id: '/admin/license-plans',
  path: '/admin/license-plans',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminLicenseDashboardRoute =
  AppAdminLicenseDashboardRouteImport.update({
    id: '/admin/license-dashboard',
    path: '/admin/license-dashboard',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminLeaveConfigRoute = AppAdminLeaveConfigRouteImport.update({
  id: '/admin/leave-config',
  path: '/admin/leave-config',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminJobsRoute = AppAdminJobsRouteImport.update({
  id: '/admin/jobs',
  path: '/admin/jobs',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminEmailLogRoute = AppAdminEmailLogRouteImport.update({
  id: '/admin/email-log',
  path: '/admin/email-log',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminCrossTenantAccessLogsRoute =
  AppAdminCrossTenantAccessLogsRouteImport.update({
    id: '/admin/cross-tenant-access-logs',
    path: '/admin/cross-tenant-access-logs',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminConnectorsRoute = AppAdminConnectorsRouteImport.update({
  id: '/admin/connectors',
  path: '/admin/connectors',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminClientIntakeRoute = AppAdminClientIntakeRouteImport.update({
  id: '/admin/client-intake',
  path: '/admin/client-intake',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminCategoriesRoute = AppAdminCategoriesRouteImport.update({
  id: '/admin/categories',
  path: '/admin/categories',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminBrandingRoute = AppAdminBrandingRouteImport.update({
  id: '/admin/branding',
  path: '/admin/branding',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminBoardConfigRoute = AppAdminBoardConfigRouteImport.update({
  id: '/admin/board-config',
  path: '/admin/board-config',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminAuditLogRoute = AppAdminAuditLogRouteImport.update({
  id: '/admin/audit-log',
  path: '/admin/audit-log',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminAttendanceSourcesRoute =
  AppAdminAttendanceSourcesRouteImport.update({
    id: '/admin/attendance-sources',
    path: '/admin/attendance-sources',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminAttendanceRemindersRoute =
  AppAdminAttendanceRemindersRouteImport.update({
    id: '/admin/attendance-reminders',
    path: '/admin/attendance-reminders',
    getParentRoute: () => AppRoute,
  } as any)
const AppWorkforceSitesIndexRoute = AppWorkforceSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppAdminTenantsIndexRoute = AppAdminTenantsIndexRouteImport.update({
  id: '/admin/tenants/',
  path: '/admin/tenants/',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkforceSitesSiteIdRoute = AppWorkforceSitesSiteIdRouteImport.update({
  id: '/sites/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppProjectsProjectIdDashboardRoute =
  AppProjectsProjectIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppFoodcostSchedaPeriodoIdRoute =
  AppFoodcostSchedaPeriodoIdRouteImport.update({
    id: '/foodcost/scheda/$periodoId',
    path: '/foodcost/scheda/$periodoId',
    getParentRoute: () => AppRoute,
  } as any)
const AppFoodcostPortaleClienteIdRoute =
  AppFoodcostPortaleClienteIdRouteImport.update({
    id: '/foodcost/portale/$clienteId',
    path: '/foodcost/portale/$clienteId',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminTenantsGroupRoute = AppAdminTenantsGroupRouteImport.update({
  id: '/admin/tenants/group',
  path: '/admin/tenants/group',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTenantsTenantIdRoute = AppAdminTenantsTenantIdRouteImport.update({
  id: '/admin/tenants/$tenantId',
  path: '/admin/tenants/$tenantId',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTenantsTenantIdSubscriptionRoute =
  AppAdminTenantsTenantIdSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AppAdminTenantsTenantIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/projects': typeof AppProjectsRouteRouteWithChildren
  '/roles': typeof AppRolesRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/templates': typeof AppTemplatesRouteRouteWithChildren
  '/timesheet': typeof AppTimesheetRouteRouteWithChildren
  '/users': typeof AppUsersRouteRouteWithChildren
  '/warehouse': typeof AppWarehouseRouteRouteWithChildren
  '/workforce': typeof AppWorkforceRouteRouteWithChildren
  '/about': typeof AppAboutRoute
  '/app-android': typeof AppAppAndroidRoute
  '/approvals': typeof AppApprovalsRoute
  '/articles': typeof AppArticlesRoute
  '/attendance': typeof AppAttendanceRoute
  '/billing': typeof AppBillingRoute
  '/car-history': typeof AppCarHistoryRoute
  '/changelog': typeof AppChangelogRoute
  '/configuration': typeof AppConfigurationRoute
  '/developer-guide': typeof AppDeveloperGuideRoute
  '/expense-reports': typeof AppExpenseReportsRoute
  '/fleet': typeof AppFleetRoute
  '/general-crud': typeof AppGeneralCrudRoute
  '/group-rules': typeof AppGroupRulesRoute
  '/help': typeof AppHelpRoute
  '/insights': typeof AppInsightsRouteWithChildren
  '/instruments-calendar': typeof AppInstrumentsCalendarRouteWithChildren
  '/intercompany': typeof AppIntercompanyRoute
  '/leave': typeof AppLeaveRouteWithChildren
  '/legal-notices': typeof AppLegalNoticesRoute
  '/legals': typeof AppLegalsRoute
  '/licensing': typeof AppLicensingRoute
  '/maeworld': typeof AppMaeworldRoute
  '/media': typeof AppMediaRoute
  '/my-subscriptions': typeof AppMySubscriptionsRoute
  '/my-vehicles': typeof AppMyVehiclesRoute
  '/my-violations': typeof AppMyViolationsRoute
  '/notes': typeof AppNotesRoute
  '/notifications': typeof AppNotificationsRouteWithChildren
  '/onboarding': typeof AppOnboardingRoute
  '/open-app': typeof AppOpenAppRoute
  '/planning': typeof AppPlanningRouteWithChildren
  '/products': typeof AppProductsRoute
  '/project-forecast': typeof AppProjectForecastRoute
  '/quality': typeof AppQualityRoute
  '/reporting': typeof AppReportingRoute
  '/service-reports': typeof AppServiceReportsRoute
  '/setup': typeof AppSetupRoute
  '/shift-swaps': typeof AppShiftSwapsRoute
  '/smart-working': typeof AppSmartWorkingRouteWithChildren
  '/sprint': typeof AppSprintRoute
  '/statistics': typeof AppStatisticsRoute
  '/support': typeof AppSupportRoute
  '/support-intake': typeof AppSupportIntakeRoute
  '/switch-tenant': typeof AppSwitchTenantRoute
  '/tasks': typeof AppTasksRouteWithChildren
  '/team-calendar': typeof AppTeamCalendarRoute
  '/team-deadlines': typeof AppTeamDeadlinesRoute
  '/test-cases': typeof AppTestCasesRoute
  '/test-coverage': typeof AppTestCoverageRoute
  '/test-plans': typeof AppTestPlansRouteWithChildren
  '/tickets': typeof AppTicketsRoute
  '/translate-structure': typeof AppTranslateStructureRoute
  '/translations': typeof AppTranslationsRoute
  '/travel': typeof AppTravelRoute
  '/update-app': typeof AppUpdateAppRoute
  '/upload-attachments': typeof AppUploadAttachmentsRoute
  '/user-audit': typeof AppUserAuditRoute
  '/user-guide': typeof AppUserGuideRoute
  '/vehicle-bookings': typeof AppVehicleBookingsRoute
  '/vehicles': typeof AppVehiclesRoute
  '/access-permissions': typeof AuthAccessPermissionsRoute
  '/login': typeof AuthLoginRoute
  '/password-reset': typeof AuthPasswordResetRoute
  '/recovery-password': typeof AuthRecoveryPasswordRoute
  '/register': typeof AuthRegisterRoute
  '/register-otp': typeof AuthRegisterOtpRoute
  '/select-tenant': typeof AuthSelectTenantRoute
  '/update-password': typeof AuthUpdatePasswordRoute
  '/download-app': typeof PublicDownloadAppRoute
  '/help-desk-unlog': typeof PublicHelpDeskUnlogRoute
  '/maintenance': typeof PublicMaintenanceRoute
  '/tenant-fallback': typeof PublicTenantFallbackRoute
  '/admin/attendance-reminders': typeof AppAdminAttendanceRemindersRoute
  '/admin/attendance-sources': typeof AppAdminAttendanceSourcesRoute
  '/admin/audit-log': typeof AppAdminAuditLogRoute
  '/admin/board-config': typeof AppAdminBoardConfigRoute
  '/admin/branding': typeof AppAdminBrandingRoute
  '/admin/categories': typeof AppAdminCategoriesRoute
  '/admin/client-intake': typeof AppAdminClientIntakeRoute
  '/admin/connectors': typeof AppAdminConnectorsRoute
  '/admin/cross-tenant-access-logs': typeof AppAdminCrossTenantAccessLogsRoute
  '/admin/email-log': typeof AppAdminEmailLogRoute
  '/admin/jobs': typeof AppAdminJobsRoute
  '/admin/leave-config': typeof AppAdminLeaveConfigRoute
  '/admin/license-dashboard': typeof AppAdminLicenseDashboardRoute
  '/admin/license-plans': typeof AppAdminLicensePlansRoute
  '/admin/licenses-catalog': typeof AppAdminLicensesCatalogRoute
  '/admin/logs': typeof AppAdminLogsRoute
  '/admin/maintenance': typeof AppAdminMaintenanceRoute
  '/admin/mcp-connections': typeof AppAdminMcpConnectionsRoute
  '/admin/mileage-rates': typeof AppAdminMileageRatesRoute
  '/admin/modules': typeof AppAdminModulesRoute
  '/admin/planning-policies': typeof AppAdminPlanningPoliciesRoute
  '/admin/policies': typeof AppAdminPoliciesRoute
  '/admin/portal-documents': typeof AppAdminPortalDocumentsRoute
  '/admin/portal-pages': typeof AppAdminPortalPagesRoute
  '/admin/project-attribute-definitions': typeof AppAdminProjectAttributeDefinitionsRoute
  '/admin/project-categories': typeof AppAdminProjectCategoriesRoute
  '/admin/project-type-presets': typeof AppAdminProjectTypePresetsRoute
  '/admin/protected-statuses': typeof AppAdminProtectedStatusesRoute
  '/admin/send-communications': typeof AppAdminSendCommunicationsRoute
  '/admin/smart-working-config': typeof AppAdminSmartWorkingConfigRoute
  '/admin/structure-labels': typeof AppAdminStructureLabelsRoute
  '/admin/subscription-types': typeof AppAdminSubscriptionTypesRoute
  '/admin/support-topics': typeof AppAdminSupportTopicsRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/admin/tardiness-policies': typeof AppAdminTardinessPoliciesRoute
  '/admin/task-labels': typeof AppAdminTaskLabelsRoute
  '/admin/task-rules': typeof AppAdminTaskRulesRoute
  '/admin/tenant-attributes': typeof AppAdminTenantAttributesRoute
  '/admin/tenant-management': typeof AppAdminTenantManagementRoute
  '/admin/tenant-users': typeof AppAdminTenantUsersRoute
  '/admin/translate-structure': typeof AppAdminTranslateStructureRoute
  '/admin/travel-policies': typeof AppAdminTravelPoliciesRoute
  '/admin/workflows': typeof AppAdminWorkflowsRoute
  '/articles/$id': typeof AppArticlesIdRoute
  '/attendance/team-month': typeof AppAttendanceTeamMonthRoute
  '/bookings/car-history': typeof AppBookingsCarHistoryRoute
  '/bookings/new': typeof AppBookingsNewRoute
  '/circulars/register': typeof AppCircularsRegisterRoute
  '/circulars/release-notes': typeof AppCircularsReleaseNotesRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/foodcost/$periodoId': typeof AppFoodcostPeriodoIdRoute
  '/foodcost/cluster': typeof AppFoodcostClusterRoute
  '/foodcost/indicatori': typeof AppFoodcostIndicatoriRoute
  '/foodcost/mappature': typeof AppFoodcostMappatureRoute
  '/foodcost/schema': typeof AppFoodcostSchemaRoute
  '/foodcost/solleciti': typeof AppFoodcostSollecitiRoute
  '/insights/monthly-invoices': typeof AppInsightsMonthlyInvoicesRoute
  '/insights/subscriptions': typeof AppInsightsSubscriptionsRoute
  '/instruments-calendar/approvals': typeof AppInstrumentsCalendarApprovalsRoute
  '/leave/approvals': typeof AppLeaveApprovalsRoute
  '/leave/new': typeof AppLeaveNewRoute
  '/mcp/authorize': typeof AppMcpAuthorizeRoute
  '/notifications/$notificationId': typeof AppNotificationsNotificationIdRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/organization/company': typeof AppOrganizationCompanyRoute
  '/organization/company-data': typeof AppOrganizationCompanyDataRoute
  '/organization/employees': typeof AppOrganizationEmployeesRoute
  '/organization/permissions': typeof AppOrganizationPermissionsRoute
  '/organization/work-rules': typeof AppOrganizationWorkRulesRoute
  '/organization/work-shifts': typeof AppOrganizationWorkShiftsRoute
  '/planning/new': typeof AppPlanningNewRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/projects/gantt': typeof AppProjectsGanttRoute
  '/projects/new': typeof AppProjectsNewRoute
  '/projects/wbs': typeof AppProjectsWbsRoute
  '/roles/$roleId': typeof AppRolesRoleIdRoute
  '/secretary/area': typeof AppSecretaryAreaRoute
  '/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/settings/devices': typeof AppSettingsDevicesRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/notification-preferences': typeof AppSettingsNotificationPreferencesRoute
  '/settings/preferences': typeof AppSettingsPreferencesRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/protected-data': typeof AppSettingsProtectedDataRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/smart-working/approvals': typeof AppSmartWorkingApprovalsRoute
  '/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/tasks/capacity': typeof AppTasksCapacityRoute
  '/tasks/card': typeof AppTasksCardRoute
  '/tasks/dashboard': typeof AppTasksDashboardRoute
  '/tasks/gantt': typeof AppTasksGanttRoute
  '/tasks/gantt-interactive': typeof AppTasksGanttInteractiveRoute
  '/tasks/kanban': typeof AppTasksKanbanRoute
  '/tasks/list': typeof AppTasksListRoute
  '/tasks/new': typeof AppTasksNewRoute
  '/tasks/notes': typeof AppTasksNotesRoute
  '/tasks/plan': typeof AppTasksPlanRoute
  '/tasks/wbs': typeof AppTasksWbsRoute
  '/templates/$templateId': typeof AppTemplatesTemplateIdRoute
  '/test-plans/$planId': typeof AppTestPlansPlanIdRoute
  '/timesheet/admin': typeof AppTimesheetAdminRoute
  '/timesheet/approval': typeof AppTimesheetApprovalRoute
  '/timesheet/by-project': typeof AppTimesheetByProjectRoute
  '/timesheet/new': typeof AppTimesheetNewRoute
  '/timesheet/reasons': typeof AppTimesheetReasonsRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/users/new': typeof AppUsersNewRoute
  '/warehouse/attributes': typeof AppWarehouseAttributesRoute
  '/warehouse/documents': typeof AppWarehouseDocumentsRoute
  '/warehouse/inventory': typeof AppWarehouseInventoryRoute
  '/warehouse/items': typeof AppWarehouseItemsRoute
  '/warehouse/locations': typeof AppWarehouseLocationsRoute
  '/warehouse/lots': typeof AppWarehouseLotsRoute
  '/warehouse/warehouses': typeof AppWarehouseWarehousesRoute
  '/workforce/$employeeId': typeof AppWorkforceEmployeeIdRoute
  '/workforce/bu': typeof AppWorkforceBuRoute
  '/workforce/dashboard': typeof AppWorkforceDashboardRoute
  '/workforce/external': typeof AppWorkforceExternalRoute
  '/workforce/hierarchy': typeof AppWorkforceHierarchyRoute
  '/workforce/roles': typeof AppWorkforceRolesRoute
  '/workforce/site-presences': typeof AppWorkforceSitePresencesRoute
  '/workforce/today': typeof AppWorkforceTodayRoute
  '/workforce/training': typeof AppWorkforceTrainingRoute
  '/portal/$modulo': typeof PortalPortalModuloRoute
  '/portal/assistenza': typeof PortalPortalAssistenzaRoute
  '/portal/attivita': typeof PortalPortalAttivitaRoute
  '/portal/azienda': typeof PortalPortalAziendaRoute
  '/portal/circulars': typeof PortalPortalCircularsRoute
  '/portal/commesse': typeof PortalPortalCommesseRoute
  '/portal/documenti': typeof PortalPortalDocumentiRoute
  '/portal/fatture': typeof PortalPortalFattureRoute
  '/portal/numeri': typeof PortalPortalNumeriRoute
  '/portal/ordini': typeof PortalPortalOrdiniRoute
  '/portal/profilo': typeof PortalPortalProfiloRoute
  '/portal/verbali': typeof PortalPortalVerbaliRoute
  '/terms/$code': typeof PublicTermsCodeRoute
  '/circulars/': typeof AppCircularsIndexRoute
  '/clients/': typeof AppClientsIndexRoute
  '/foodcost/': typeof AppFoodcostIndexRoute
  '/instruments-calendar/': typeof AppInstrumentsCalendarIndexRoute
  '/leave/': typeof AppLeaveIndexRoute
  '/notifications/': typeof AppNotificationsIndexRoute
  '/orders/': typeof AppOrdersIndexRoute
  '/planning/': typeof AppPlanningIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/roles/': typeof AppRolesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/smart-working/': typeof AppSmartWorkingIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/templates/': typeof AppTemplatesIndexRoute
  '/test-plans/': typeof AppTestPlansIndexRoute
  '/timesheet/': typeof AppTimesheetIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/warehouse/': typeof AppWarehouseIndexRoute
  '/workforce/': typeof AppWorkforceIndexRoute
  '/portal/': typeof PortalPortalIndexRoute
  '/admin/tenants/$tenantId': typeof AppAdminTenantsTenantIdRouteWithChildren
  '/admin/tenants/group': typeof AppAdminTenantsGroupRoute
  '/foodcost/portale/$clienteId': typeof AppFoodcostPortaleClienteIdRoute
  '/foodcost/scheda/$periodoId': typeof AppFoodcostSchedaPeriodoIdRoute
  '/projects/$projectId/dashboard': typeof AppProjectsProjectIdDashboardRoute
  '/workforce/sites/$siteId': typeof AppWorkforceSitesSiteIdRoute
  '/admin/tenants/': typeof AppAdminTenantsIndexRoute
  '/workforce/sites/': typeof AppWorkforceSitesIndexRoute
  '/admin/tenants/$tenantId/subscription': typeof AppAdminTenantsTenantIdSubscriptionRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/about': typeof AppAboutRoute
  '/app-android': typeof AppAppAndroidRoute
  '/approvals': typeof AppApprovalsRoute
  '/articles': typeof AppArticlesRoute
  '/attendance': typeof AppAttendanceRoute
  '/billing': typeof AppBillingRoute
  '/car-history': typeof AppCarHistoryRoute
  '/changelog': typeof AppChangelogRoute
  '/configuration': typeof AppConfigurationRoute
  '/developer-guide': typeof AppDeveloperGuideRoute
  '/expense-reports': typeof AppExpenseReportsRoute
  '/fleet': typeof AppFleetRoute
  '/general-crud': typeof AppGeneralCrudRoute
  '/group-rules': typeof AppGroupRulesRoute
  '/help': typeof AppHelpRoute
  '/insights': typeof AppInsightsRouteWithChildren
  '/intercompany': typeof AppIntercompanyRoute
  '/legal-notices': typeof AppLegalNoticesRoute
  '/legals': typeof AppLegalsRoute
  '/licensing': typeof AppLicensingRoute
  '/maeworld': typeof AppMaeworldRoute
  '/media': typeof AppMediaRoute
  '/my-subscriptions': typeof AppMySubscriptionsRoute
  '/my-vehicles': typeof AppMyVehiclesRoute
  '/my-violations': typeof AppMyViolationsRoute
  '/notes': typeof AppNotesRoute
  '/onboarding': typeof AppOnboardingRoute
  '/open-app': typeof AppOpenAppRoute
  '/products': typeof AppProductsRoute
  '/project-forecast': typeof AppProjectForecastRoute
  '/quality': typeof AppQualityRoute
  '/reporting': typeof AppReportingRoute
  '/service-reports': typeof AppServiceReportsRoute
  '/setup': typeof AppSetupRoute
  '/shift-swaps': typeof AppShiftSwapsRoute
  '/sprint': typeof AppSprintRoute
  '/statistics': typeof AppStatisticsRoute
  '/support': typeof AppSupportRoute
  '/support-intake': typeof AppSupportIntakeRoute
  '/switch-tenant': typeof AppSwitchTenantRoute
  '/team-calendar': typeof AppTeamCalendarRoute
  '/team-deadlines': typeof AppTeamDeadlinesRoute
  '/test-cases': typeof AppTestCasesRoute
  '/test-coverage': typeof AppTestCoverageRoute
  '/tickets': typeof AppTicketsRoute
  '/translate-structure': typeof AppTranslateStructureRoute
  '/translations': typeof AppTranslationsRoute
  '/travel': typeof AppTravelRoute
  '/update-app': typeof AppUpdateAppRoute
  '/upload-attachments': typeof AppUploadAttachmentsRoute
  '/user-audit': typeof AppUserAuditRoute
  '/user-guide': typeof AppUserGuideRoute
  '/vehicle-bookings': typeof AppVehicleBookingsRoute
  '/vehicles': typeof AppVehiclesRoute
  '/access-permissions': typeof AuthAccessPermissionsRoute
  '/login': typeof AuthLoginRoute
  '/password-reset': typeof AuthPasswordResetRoute
  '/recovery-password': typeof AuthRecoveryPasswordRoute
  '/register': typeof AuthRegisterRoute
  '/register-otp': typeof AuthRegisterOtpRoute
  '/select-tenant': typeof AuthSelectTenantRoute
  '/update-password': typeof AuthUpdatePasswordRoute
  '/download-app': typeof PublicDownloadAppRoute
  '/help-desk-unlog': typeof PublicHelpDeskUnlogRoute
  '/maintenance': typeof PublicMaintenanceRoute
  '/tenant-fallback': typeof PublicTenantFallbackRoute
  '/admin/attendance-reminders': typeof AppAdminAttendanceRemindersRoute
  '/admin/attendance-sources': typeof AppAdminAttendanceSourcesRoute
  '/admin/audit-log': typeof AppAdminAuditLogRoute
  '/admin/board-config': typeof AppAdminBoardConfigRoute
  '/admin/branding': typeof AppAdminBrandingRoute
  '/admin/categories': typeof AppAdminCategoriesRoute
  '/admin/client-intake': typeof AppAdminClientIntakeRoute
  '/admin/connectors': typeof AppAdminConnectorsRoute
  '/admin/cross-tenant-access-logs': typeof AppAdminCrossTenantAccessLogsRoute
  '/admin/email-log': typeof AppAdminEmailLogRoute
  '/admin/jobs': typeof AppAdminJobsRoute
  '/admin/leave-config': typeof AppAdminLeaveConfigRoute
  '/admin/license-dashboard': typeof AppAdminLicenseDashboardRoute
  '/admin/license-plans': typeof AppAdminLicensePlansRoute
  '/admin/licenses-catalog': typeof AppAdminLicensesCatalogRoute
  '/admin/logs': typeof AppAdminLogsRoute
  '/admin/maintenance': typeof AppAdminMaintenanceRoute
  '/admin/mcp-connections': typeof AppAdminMcpConnectionsRoute
  '/admin/mileage-rates': typeof AppAdminMileageRatesRoute
  '/admin/modules': typeof AppAdminModulesRoute
  '/admin/planning-policies': typeof AppAdminPlanningPoliciesRoute
  '/admin/policies': typeof AppAdminPoliciesRoute
  '/admin/portal-documents': typeof AppAdminPortalDocumentsRoute
  '/admin/portal-pages': typeof AppAdminPortalPagesRoute
  '/admin/project-attribute-definitions': typeof AppAdminProjectAttributeDefinitionsRoute
  '/admin/project-categories': typeof AppAdminProjectCategoriesRoute
  '/admin/project-type-presets': typeof AppAdminProjectTypePresetsRoute
  '/admin/protected-statuses': typeof AppAdminProtectedStatusesRoute
  '/admin/send-communications': typeof AppAdminSendCommunicationsRoute
  '/admin/smart-working-config': typeof AppAdminSmartWorkingConfigRoute
  '/admin/structure-labels': typeof AppAdminStructureLabelsRoute
  '/admin/subscription-types': typeof AppAdminSubscriptionTypesRoute
  '/admin/support-topics': typeof AppAdminSupportTopicsRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/admin/tardiness-policies': typeof AppAdminTardinessPoliciesRoute
  '/admin/task-labels': typeof AppAdminTaskLabelsRoute
  '/admin/task-rules': typeof AppAdminTaskRulesRoute
  '/admin/tenant-attributes': typeof AppAdminTenantAttributesRoute
  '/admin/tenant-management': typeof AppAdminTenantManagementRoute
  '/admin/tenant-users': typeof AppAdminTenantUsersRoute
  '/admin/translate-structure': typeof AppAdminTranslateStructureRoute
  '/admin/travel-policies': typeof AppAdminTravelPoliciesRoute
  '/admin/workflows': typeof AppAdminWorkflowsRoute
  '/articles/$id': typeof AppArticlesIdRoute
  '/attendance/team-month': typeof AppAttendanceTeamMonthRoute
  '/bookings/car-history': typeof AppBookingsCarHistoryRoute
  '/bookings/new': typeof AppBookingsNewRoute
  '/circulars/register': typeof AppCircularsRegisterRoute
  '/circulars/release-notes': typeof AppCircularsReleaseNotesRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/foodcost/$periodoId': typeof AppFoodcostPeriodoIdRoute
  '/foodcost/cluster': typeof AppFoodcostClusterRoute
  '/foodcost/indicatori': typeof AppFoodcostIndicatoriRoute
  '/foodcost/mappature': typeof AppFoodcostMappatureRoute
  '/foodcost/schema': typeof AppFoodcostSchemaRoute
  '/foodcost/solleciti': typeof AppFoodcostSollecitiRoute
  '/insights/monthly-invoices': typeof AppInsightsMonthlyInvoicesRoute
  '/insights/subscriptions': typeof AppInsightsSubscriptionsRoute
  '/instruments-calendar/approvals': typeof AppInstrumentsCalendarApprovalsRoute
  '/leave/approvals': typeof AppLeaveApprovalsRoute
  '/leave/new': typeof AppLeaveNewRoute
  '/mcp/authorize': typeof AppMcpAuthorizeRoute
  '/notifications/$notificationId': typeof AppNotificationsNotificationIdRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/organization/company': typeof AppOrganizationCompanyRoute
  '/organization/company-data': typeof AppOrganizationCompanyDataRoute
  '/organization/employees': typeof AppOrganizationEmployeesRoute
  '/organization/permissions': typeof AppOrganizationPermissionsRoute
  '/organization/work-rules': typeof AppOrganizationWorkRulesRoute
  '/organization/work-shifts': typeof AppOrganizationWorkShiftsRoute
  '/planning/new': typeof AppPlanningNewRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/projects/gantt': typeof AppProjectsGanttRoute
  '/projects/new': typeof AppProjectsNewRoute
  '/projects/wbs': typeof AppProjectsWbsRoute
  '/roles/$roleId': typeof AppRolesRoleIdRoute
  '/secretary/area': typeof AppSecretaryAreaRoute
  '/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/settings/devices': typeof AppSettingsDevicesRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/notification-preferences': typeof AppSettingsNotificationPreferencesRoute
  '/settings/preferences': typeof AppSettingsPreferencesRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/protected-data': typeof AppSettingsProtectedDataRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/smart-working/approvals': typeof AppSmartWorkingApprovalsRoute
  '/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/tasks/capacity': typeof AppTasksCapacityRoute
  '/tasks/card': typeof AppTasksCardRoute
  '/tasks/dashboard': typeof AppTasksDashboardRoute
  '/tasks/gantt': typeof AppTasksGanttRoute
  '/tasks/gantt-interactive': typeof AppTasksGanttInteractiveRoute
  '/tasks/kanban': typeof AppTasksKanbanRoute
  '/tasks/list': typeof AppTasksListRoute
  '/tasks/new': typeof AppTasksNewRoute
  '/tasks/notes': typeof AppTasksNotesRoute
  '/tasks/plan': typeof AppTasksPlanRoute
  '/tasks/wbs': typeof AppTasksWbsRoute
  '/templates/$templateId': typeof AppTemplatesTemplateIdRoute
  '/test-plans/$planId': typeof AppTestPlansPlanIdRoute
  '/timesheet/admin': typeof AppTimesheetAdminRoute
  '/timesheet/approval': typeof AppTimesheetApprovalRoute
  '/timesheet/by-project': typeof AppTimesheetByProjectRoute
  '/timesheet/new': typeof AppTimesheetNewRoute
  '/timesheet/reasons': typeof AppTimesheetReasonsRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/users/new': typeof AppUsersNewRoute
  '/warehouse/attributes': typeof AppWarehouseAttributesRoute
  '/warehouse/documents': typeof AppWarehouseDocumentsRoute
  '/warehouse/inventory': typeof AppWarehouseInventoryRoute
  '/warehouse/items': typeof AppWarehouseItemsRoute
  '/warehouse/locations': typeof AppWarehouseLocationsRoute
  '/warehouse/lots': typeof AppWarehouseLotsRoute
  '/warehouse/warehouses': typeof AppWarehouseWarehousesRoute
  '/workforce/$employeeId': typeof AppWorkforceEmployeeIdRoute
  '/workforce/bu': typeof AppWorkforceBuRoute
  '/workforce/dashboard': typeof AppWorkforceDashboardRoute
  '/workforce/external': typeof AppWorkforceExternalRoute
  '/workforce/hierarchy': typeof AppWorkforceHierarchyRoute
  '/workforce/roles': typeof AppWorkforceRolesRoute
  '/workforce/site-presences': typeof AppWorkforceSitePresencesRoute
  '/workforce/today': typeof AppWorkforceTodayRoute
  '/workforce/training': typeof AppWorkforceTrainingRoute
  '/portal/$modulo': typeof PortalPortalModuloRoute
  '/portal/assistenza': typeof PortalPortalAssistenzaRoute
  '/portal/attivita': typeof PortalPortalAttivitaRoute
  '/portal/azienda': typeof PortalPortalAziendaRoute
  '/portal/circulars': typeof PortalPortalCircularsRoute
  '/portal/commesse': typeof PortalPortalCommesseRoute
  '/portal/documenti': typeof PortalPortalDocumentiRoute
  '/portal/fatture': typeof PortalPortalFattureRoute
  '/portal/numeri': typeof PortalPortalNumeriRoute
  '/portal/ordini': typeof PortalPortalOrdiniRoute
  '/portal/profilo': typeof PortalPortalProfiloRoute
  '/portal/verbali': typeof PortalPortalVerbaliRoute
  '/terms/$code': typeof PublicTermsCodeRoute
  '/circulars': typeof AppCircularsIndexRoute
  '/clients': typeof AppClientsIndexRoute
  '/foodcost': typeof AppFoodcostIndexRoute
  '/instruments-calendar': typeof AppInstrumentsCalendarIndexRoute
  '/leave': typeof AppLeaveIndexRoute
  '/notifications': typeof AppNotificationsIndexRoute
  '/orders': typeof AppOrdersIndexRoute
  '/planning': typeof AppPlanningIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/roles': typeof AppRolesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/smart-working': typeof AppSmartWorkingIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/templates': typeof AppTemplatesIndexRoute
  '/test-plans': typeof AppTestPlansIndexRoute
  '/timesheet': typeof AppTimesheetIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/warehouse': typeof AppWarehouseIndexRoute
  '/workforce': typeof AppWorkforceIndexRoute
  '/portal': typeof PortalPortalIndexRoute
  '/admin/tenants/$tenantId': typeof AppAdminTenantsTenantIdRouteWithChildren
  '/admin/tenants/group': typeof AppAdminTenantsGroupRoute
  '/foodcost/portale/$clienteId': typeof AppFoodcostPortaleClienteIdRoute
  '/foodcost/scheda/$periodoId': typeof AppFoodcostSchedaPeriodoIdRoute
  '/projects/$projectId/dashboard': typeof AppProjectsProjectIdDashboardRoute
  '/workforce/sites/$siteId': typeof AppWorkforceSitesSiteIdRoute
  '/admin/tenants': typeof AppAdminTenantsIndexRoute
  '/workforce/sites': typeof AppWorkforceSitesIndexRoute
  '/admin/tenants/$tenantId/subscription': typeof AppAdminTenantsTenantIdSubscriptionRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_portal': typeof PortalRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_app/projects': typeof AppProjectsRouteRouteWithChildren
  '/_app/roles': typeof AppRolesRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/templates': typeof AppTemplatesRouteRouteWithChildren
  '/_app/timesheet': typeof AppTimesheetRouteRouteWithChildren
  '/_app/users': typeof AppUsersRouteRouteWithChildren
  '/_app/warehouse': typeof AppWarehouseRouteRouteWithChildren
  '/_app/workforce': typeof AppWorkforceRouteRouteWithChildren
  '/_app/about': typeof AppAboutRoute
  '/_app/app-android': typeof AppAppAndroidRoute
  '/_app/approvals': typeof AppApprovalsRoute
  '/_app/articles': typeof AppArticlesRoute
  '/_app/attendance': typeof AppAttendanceRoute
  '/_app/billing': typeof AppBillingRoute
  '/_app/car-history': typeof AppCarHistoryRoute
  '/_app/changelog': typeof AppChangelogRoute
  '/_app/configuration': typeof AppConfigurationRoute
  '/_app/developer-guide': typeof AppDeveloperGuideRoute
  '/_app/expense-reports': typeof AppExpenseReportsRoute
  '/_app/fleet': typeof AppFleetRoute
  '/_app/general-crud': typeof AppGeneralCrudRoute
  '/_app/group-rules': typeof AppGroupRulesRoute
  '/_app/help': typeof AppHelpRoute
  '/_app/insights': typeof AppInsightsRouteWithChildren
  '/_app/instruments-calendar': typeof AppInstrumentsCalendarRouteWithChildren
  '/_app/intercompany': typeof AppIntercompanyRoute
  '/_app/leave': typeof AppLeaveRouteWithChildren
  '/_app/legal-notices': typeof AppLegalNoticesRoute
  '/_app/legals': typeof AppLegalsRoute
  '/_app/licensing': typeof AppLicensingRoute
  '/_app/maeworld': typeof AppMaeworldRoute
  '/_app/media': typeof AppMediaRoute
  '/_app/my-subscriptions': typeof AppMySubscriptionsRoute
  '/_app/my-vehicles': typeof AppMyVehiclesRoute
  '/_app/my-violations': typeof AppMyViolationsRoute
  '/_app/notes': typeof AppNotesRoute
  '/_app/notifications': typeof AppNotificationsRouteWithChildren
  '/_app/onboarding': typeof AppOnboardingRoute
  '/_app/open-app': typeof AppOpenAppRoute
  '/_app/planning': typeof AppPlanningRouteWithChildren
  '/_app/products': typeof AppProductsRoute
  '/_app/project-forecast': typeof AppProjectForecastRoute
  '/_app/quality': typeof AppQualityRoute
  '/_app/reporting': typeof AppReportingRoute
  '/_app/service-reports': typeof AppServiceReportsRoute
  '/_app/setup': typeof AppSetupRoute
  '/_app/shift-swaps': typeof AppShiftSwapsRoute
  '/_app/smart-working': typeof AppSmartWorkingRouteWithChildren
  '/_app/sprint': typeof AppSprintRoute
  '/_app/statistics': typeof AppStatisticsRoute
  '/_app/support': typeof AppSupportRoute
  '/_app/support-intake': typeof AppSupportIntakeRoute
  '/_app/switch-tenant': typeof AppSwitchTenantRoute
  '/_app/tasks': typeof AppTasksRouteWithChildren
  '/_app/team-calendar': typeof AppTeamCalendarRoute
  '/_app/team-deadlines': typeof AppTeamDeadlinesRoute
  '/_app/test-cases': typeof AppTestCasesRoute
  '/_app/test-coverage': typeof AppTestCoverageRoute
  '/_app/test-plans': typeof AppTestPlansRouteWithChildren
  '/_app/tickets': typeof AppTicketsRoute
  '/_app/translate-structure': typeof AppTranslateStructureRoute
  '/_app/translations': typeof AppTranslationsRoute
  '/_app/travel': typeof AppTravelRoute
  '/_app/update-app': typeof AppUpdateAppRoute
  '/_app/upload-attachments': typeof AppUploadAttachmentsRoute
  '/_app/user-audit': typeof AppUserAuditRoute
  '/_app/user-guide': typeof AppUserGuideRoute
  '/_app/vehicle-bookings': typeof AppVehicleBookingsRoute
  '/_app/vehicles': typeof AppVehiclesRoute
  '/_auth/access-permissions': typeof AuthAccessPermissionsRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/password-reset': typeof AuthPasswordResetRoute
  '/_auth/recovery-password': typeof AuthRecoveryPasswordRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/register-otp': typeof AuthRegisterOtpRoute
  '/_auth/select-tenant': typeof AuthSelectTenantRoute
  '/_auth/update-password': typeof AuthUpdatePasswordRoute
  '/_public/download-app': typeof PublicDownloadAppRoute
  '/_public/help-desk-unlog': typeof PublicHelpDeskUnlogRoute
  '/_public/maintenance': typeof PublicMaintenanceRoute
  '/_public/tenant-fallback': typeof PublicTenantFallbackRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/attendance-reminders': typeof AppAdminAttendanceRemindersRoute
  '/_app/admin/attendance-sources': typeof AppAdminAttendanceSourcesRoute
  '/_app/admin/audit-log': typeof AppAdminAuditLogRoute
  '/_app/admin/board-config': typeof AppAdminBoardConfigRoute
  '/_app/admin/branding': typeof AppAdminBrandingRoute
  '/_app/admin/categories': typeof AppAdminCategoriesRoute
  '/_app/admin/client-intake': typeof AppAdminClientIntakeRoute
  '/_app/admin/connectors': typeof AppAdminConnectorsRoute
  '/_app/admin/cross-tenant-access-logs': typeof AppAdminCrossTenantAccessLogsRoute
  '/_app/admin/email-log': typeof AppAdminEmailLogRoute
  '/_app/admin/jobs': typeof AppAdminJobsRoute
  '/_app/admin/leave-config': typeof AppAdminLeaveConfigRoute
  '/_app/admin/license-dashboard': typeof AppAdminLicenseDashboardRoute
  '/_app/admin/license-plans': typeof AppAdminLicensePlansRoute
  '/_app/admin/licenses-catalog': typeof AppAdminLicensesCatalogRoute
  '/_app/admin/logs': typeof AppAdminLogsRoute
  '/_app/admin/maintenance': typeof AppAdminMaintenanceRoute
  '/_app/admin/mcp-connections': typeof AppAdminMcpConnectionsRoute
  '/_app/admin/mileage-rates': typeof AppAdminMileageRatesRoute
  '/_app/admin/modules': typeof AppAdminModulesRoute
  '/_app/admin/planning-policies': typeof AppAdminPlanningPoliciesRoute
  '/_app/admin/policies': typeof AppAdminPoliciesRoute
  '/_app/admin/portal-documents': typeof AppAdminPortalDocumentsRoute
  '/_app/admin/portal-pages': typeof AppAdminPortalPagesRoute
  '/_app/admin/project-attribute-definitions': typeof AppAdminProjectAttributeDefinitionsRoute
  '/_app/admin/project-categories': typeof AppAdminProjectCategoriesRoute
  '/_app/admin/project-type-presets': typeof AppAdminProjectTypePresetsRoute
  '/_app/admin/protected-statuses': typeof AppAdminProtectedStatusesRoute
  '/_app/admin/send-communications': typeof AppAdminSendCommunicationsRoute
  '/_app/admin/smart-working-config': typeof AppAdminSmartWorkingConfigRoute
  '/_app/admin/structure-labels': typeof AppAdminStructureLabelsRoute
  '/_app/admin/subscription-types': typeof AppAdminSubscriptionTypesRoute
  '/_app/admin/support-topics': typeof AppAdminSupportTopicsRoute
  '/_app/admin/system': typeof AppAdminSystemRoute
  '/_app/admin/tardiness-policies': typeof AppAdminTardinessPoliciesRoute
  '/_app/admin/task-labels': typeof AppAdminTaskLabelsRoute
  '/_app/admin/task-rules': typeof AppAdminTaskRulesRoute
  '/_app/admin/tenant-attributes': typeof AppAdminTenantAttributesRoute
  '/_app/admin/tenant-management': typeof AppAdminTenantManagementRoute
  '/_app/admin/tenant-users': typeof AppAdminTenantUsersRoute
  '/_app/admin/translate-structure': typeof AppAdminTranslateStructureRoute
  '/_app/admin/travel-policies': typeof AppAdminTravelPoliciesRoute
  '/_app/admin/workflows': typeof AppAdminWorkflowsRoute
  '/_app/articles_/$id': typeof AppArticlesIdRoute
  '/_app/attendance_/team-month': typeof AppAttendanceTeamMonthRoute
  '/_app/bookings/car-history': typeof AppBookingsCarHistoryRoute
  '/_app/bookings/new': typeof AppBookingsNewRoute
  '/_app/circulars/register': typeof AppCircularsRegisterRoute
  '/_app/circulars/release-notes': typeof AppCircularsReleaseNotesRoute
  '/_app/clients/$clientId': typeof AppClientsClientIdRoute
  '/_app/foodcost/$periodoId': typeof AppFoodcostPeriodoIdRoute
  '/_app/foodcost/cluster': typeof AppFoodcostClusterRoute
  '/_app/foodcost/indicatori': typeof AppFoodcostIndicatoriRoute
  '/_app/foodcost/mappature': typeof AppFoodcostMappatureRoute
  '/_app/foodcost/schema': typeof AppFoodcostSchemaRoute
  '/_app/foodcost/solleciti': typeof AppFoodcostSollecitiRoute
  '/_app/insights/monthly-invoices': typeof AppInsightsMonthlyInvoicesRoute
  '/_app/insights/subscriptions': typeof AppInsightsSubscriptionsRoute
  '/_app/instruments-calendar/approvals': typeof AppInstrumentsCalendarApprovalsRoute
  '/_app/leave/approvals': typeof AppLeaveApprovalsRoute
  '/_app/leave/new': typeof AppLeaveNewRoute
  '/_app/mcp/authorize': typeof AppMcpAuthorizeRoute
  '/_app/notifications/$notificationId': typeof AppNotificationsNotificationIdRoute
  '/_app/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/_app/organization/company': typeof AppOrganizationCompanyRoute
  '/_app/organization/company-data': typeof AppOrganizationCompanyDataRoute
  '/_app/organization/employees': typeof AppOrganizationEmployeesRoute
  '/_app/organization/permissions': typeof AppOrganizationPermissionsRoute
  '/_app/organization/work-rules': typeof AppOrganizationWorkRulesRoute
  '/_app/organization/work-shifts': typeof AppOrganizationWorkShiftsRoute
  '/_app/planning/new': typeof AppPlanningNewRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/_app/projects/gantt': typeof AppProjectsGanttRoute
  '/_app/projects/new': typeof AppProjectsNewRoute
  '/_app/projects/wbs': typeof AppProjectsWbsRoute
  '/_app/roles/$roleId': typeof AppRolesRoleIdRoute
  '/_app/secretary/area': typeof AppSecretaryAreaRoute
  '/_app/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/_app/settings/devices': typeof AppSettingsDevicesRoute
  '/_app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/_app/settings/notification-preferences': typeof AppSettingsNotificationPreferencesRoute
  '/_app/settings/preferences': typeof AppSettingsPreferencesRoute
  '/_app/settings/privacy': typeof AppSettingsPrivacyRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/protected-data': typeof AppSettingsProtectedDataRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/smart-working/approvals': typeof AppSmartWorkingApprovalsRoute
  '/_app/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/_app/tasks/capacity': typeof AppTasksCapacityRoute
  '/_app/tasks/card': typeof AppTasksCardRoute
  '/_app/tasks/dashboard': typeof AppTasksDashboardRoute
  '/_app/tasks/gantt': typeof AppTasksGanttRoute
  '/_app/tasks/gantt-interactive': typeof AppTasksGanttInteractiveRoute
  '/_app/tasks/kanban': typeof AppTasksKanbanRoute
  '/_app/tasks/list': typeof AppTasksListRoute
  '/_app/tasks/new': typeof AppTasksNewRoute
  '/_app/tasks/notes': typeof AppTasksNotesRoute
  '/_app/tasks/plan': typeof AppTasksPlanRoute
  '/_app/tasks/wbs': typeof AppTasksWbsRoute
  '/_app/templates/$templateId': typeof AppTemplatesTemplateIdRoute
  '/_app/test-plans/$planId': typeof AppTestPlansPlanIdRoute
  '/_app/timesheet/admin': typeof AppTimesheetAdminRoute
  '/_app/timesheet/approval': typeof AppTimesheetApprovalRoute
  '/_app/timesheet/by-project': typeof AppTimesheetByProjectRoute
  '/_app/timesheet/new': typeof AppTimesheetNewRoute
  '/_app/timesheet/reasons': typeof AppTimesheetReasonsRoute
  '/_app/users/$userId': typeof AppUsersUserIdRoute
  '/_app/users/new': typeof AppUsersNewRoute
  '/_app/warehouse/attributes': typeof AppWarehouseAttributesRoute
  '/_app/warehouse/documents': typeof AppWarehouseDocumentsRoute
  '/_app/warehouse/inventory': typeof AppWarehouseInventoryRoute
  '/_app/warehouse/items': typeof AppWarehouseItemsRoute
  '/_app/warehouse/locations': typeof AppWarehouseLocationsRoute
  '/_app/warehouse/lots': typeof AppWarehouseLotsRoute
  '/_app/warehouse/warehouses': typeof AppWarehouseWarehousesRoute
  '/_app/workforce/$employeeId': typeof AppWorkforceEmployeeIdRoute
  '/_app/workforce/bu': typeof AppWorkforceBuRoute
  '/_app/workforce/dashboard': typeof AppWorkforceDashboardRoute
  '/_app/workforce/external': typeof AppWorkforceExternalRoute
  '/_app/workforce/hierarchy': typeof AppWorkforceHierarchyRoute
  '/_app/workforce/roles': typeof AppWorkforceRolesRoute
  '/_app/workforce/site-presences': typeof AppWorkforceSitePresencesRoute
  '/_app/workforce/today': typeof AppWorkforceTodayRoute
  '/_app/workforce/training': typeof AppWorkforceTrainingRoute
  '/_portal/portal/$modulo': typeof PortalPortalModuloRoute
  '/_portal/portal/assistenza': typeof PortalPortalAssistenzaRoute
  '/_portal/portal/attivita': typeof PortalPortalAttivitaRoute
  '/_portal/portal/azienda': typeof PortalPortalAziendaRoute
  '/_portal/portal/circulars': typeof PortalPortalCircularsRoute
  '/_portal/portal/commesse': typeof PortalPortalCommesseRoute
  '/_portal/portal/documenti': typeof PortalPortalDocumentiRoute
  '/_portal/portal/fatture': typeof PortalPortalFattureRoute
  '/_portal/portal/numeri': typeof PortalPortalNumeriRoute
  '/_portal/portal/ordini': typeof PortalPortalOrdiniRoute
  '/_portal/portal/profilo': typeof PortalPortalProfiloRoute
  '/_portal/portal/verbali': typeof PortalPortalVerbaliRoute
  '/_public/terms/$code': typeof PublicTermsCodeRoute
  '/_app/circulars/': typeof AppCircularsIndexRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/foodcost/': typeof AppFoodcostIndexRoute
  '/_app/instruments-calendar/': typeof AppInstrumentsCalendarIndexRoute
  '/_app/leave/': typeof AppLeaveIndexRoute
  '/_app/notifications/': typeof AppNotificationsIndexRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
  '/_app/planning/': typeof AppPlanningIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/roles/': typeof AppRolesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/smart-working/': typeof AppSmartWorkingIndexRoute
  '/_app/tasks/': typeof AppTasksIndexRoute
  '/_app/templates/': typeof AppTemplatesIndexRoute
  '/_app/test-plans/': typeof AppTestPlansIndexRoute
  '/_app/timesheet/': typeof AppTimesheetIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/warehouse/': typeof AppWarehouseIndexRoute
  '/_app/workforce/': typeof AppWorkforceIndexRoute
  '/_portal/portal/': typeof PortalPortalIndexRoute
  '/_app/admin/tenants/$tenantId': typeof AppAdminTenantsTenantIdRouteWithChildren
  '/_app/admin/tenants/group': typeof AppAdminTenantsGroupRoute
  '/_app/foodcost/portale/$clienteId': typeof AppFoodcostPortaleClienteIdRoute
  '/_app/foodcost/scheda/$periodoId': typeof AppFoodcostSchedaPeriodoIdRoute
  '/_app/projects/$projectId/dashboard': typeof AppProjectsProjectIdDashboardRoute
  '/_app/workforce/sites/$siteId': typeof AppWorkforceSitesSiteIdRoute
  '/_app/admin/tenants/': typeof AppAdminTenantsIndexRoute
  '/_app/workforce/sites/': typeof AppWorkforceSitesIndexRoute
  '/_app/admin/tenants/$tenantId/subscription': typeof AppAdminTenantsTenantIdSubscriptionRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/projects'
    | '/roles'
    | '/settings'
    | '/templates'
    | '/timesheet'
    | '/users'
    | '/warehouse'
    | '/workforce'
    | '/about'
    | '/app-android'
    | '/approvals'
    | '/articles'
    | '/attendance'
    | '/billing'
    | '/car-history'
    | '/changelog'
    | '/configuration'
    | '/developer-guide'
    | '/expense-reports'
    | '/fleet'
    | '/general-crud'
    | '/group-rules'
    | '/help'
    | '/insights'
    | '/instruments-calendar'
    | '/intercompany'
    | '/leave'
    | '/legal-notices'
    | '/legals'
    | '/licensing'
    | '/maeworld'
    | '/media'
    | '/my-subscriptions'
    | '/my-vehicles'
    | '/my-violations'
    | '/notes'
    | '/notifications'
    | '/onboarding'
    | '/open-app'
    | '/planning'
    | '/products'
    | '/project-forecast'
    | '/quality'
    | '/reporting'
    | '/service-reports'
    | '/setup'
    | '/shift-swaps'
    | '/smart-working'
    | '/sprint'
    | '/statistics'
    | '/support'
    | '/support-intake'
    | '/switch-tenant'
    | '/tasks'
    | '/team-calendar'
    | '/team-deadlines'
    | '/test-cases'
    | '/test-coverage'
    | '/test-plans'
    | '/tickets'
    | '/translate-structure'
    | '/translations'
    | '/travel'
    | '/update-app'
    | '/upload-attachments'
    | '/user-audit'
    | '/user-guide'
    | '/vehicle-bookings'
    | '/vehicles'
    | '/access-permissions'
    | '/login'
    | '/password-reset'
    | '/recovery-password'
    | '/register'
    | '/register-otp'
    | '/select-tenant'
    | '/update-password'
    | '/download-app'
    | '/help-desk-unlog'
    | '/maintenance'
    | '/tenant-fallback'
    | '/admin/attendance-reminders'
    | '/admin/attendance-sources'
    | '/admin/audit-log'
    | '/admin/board-config'
    | '/admin/branding'
    | '/admin/categories'
    | '/admin/client-intake'
    | '/admin/connectors'
    | '/admin/cross-tenant-access-logs'
    | '/admin/email-log'
    | '/admin/jobs'
    | '/admin/leave-config'
    | '/admin/license-dashboard'
    | '/admin/license-plans'
    | '/admin/licenses-catalog'
    | '/admin/logs'
    | '/admin/maintenance'
    | '/admin/mcp-connections'
    | '/admin/mileage-rates'
    | '/admin/modules'
    | '/admin/planning-policies'
    | '/admin/policies'
    | '/admin/portal-documents'
    | '/admin/portal-pages'
    | '/admin/project-attribute-definitions'
    | '/admin/project-categories'
    | '/admin/project-type-presets'
    | '/admin/protected-statuses'
    | '/admin/send-communications'
    | '/admin/smart-working-config'
    | '/admin/structure-labels'
    | '/admin/subscription-types'
    | '/admin/support-topics'
    | '/admin/system'
    | '/admin/tardiness-policies'
    | '/admin/task-labels'
    | '/admin/task-rules'
    | '/admin/tenant-attributes'
    | '/admin/tenant-management'
    | '/admin/tenant-users'
    | '/admin/translate-structure'
    | '/admin/travel-policies'
    | '/admin/workflows'
    | '/articles/$id'
    | '/attendance/team-month'
    | '/bookings/car-history'
    | '/bookings/new'
    | '/circulars/register'
    | '/circulars/release-notes'
    | '/clients/$clientId'
    | '/foodcost/$periodoId'
    | '/foodcost/cluster'
    | '/foodcost/indicatori'
    | '/foodcost/mappature'
    | '/foodcost/schema'
    | '/foodcost/solleciti'
    | '/insights/monthly-invoices'
    | '/insights/subscriptions'
    | '/instruments-calendar/approvals'
    | '/leave/approvals'
    | '/leave/new'
    | '/mcp/authorize'
    | '/notifications/$notificationId'
    | '/orders/$orderId'
    | '/organization/company'
    | '/organization/company-data'
    | '/organization/employees'
    | '/organization/permissions'
    | '/organization/work-rules'
    | '/organization/work-shifts'
    | '/planning/new'
    | '/projects/$projectId'
    | '/projects/gantt'
    | '/projects/new'
    | '/projects/wbs'
    | '/roles/$roleId'
    | '/secretary/area'
    | '/settings/api-keys'
    | '/settings/devices'
    | '/settings/integrations'
    | '/settings/notification-preferences'
    | '/settings/preferences'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/protected-data'
    | '/settings/security'
    | '/smart-working/approvals'
    | '/tasks/$taskId'
    | '/tasks/capacity'
    | '/tasks/card'
    | '/tasks/dashboard'
    | '/tasks/gantt'
    | '/tasks/gantt-interactive'
    | '/tasks/kanban'
    | '/tasks/list'
    | '/tasks/new'
    | '/tasks/notes'
    | '/tasks/plan'
    | '/tasks/wbs'
    | '/templates/$templateId'
    | '/test-plans/$planId'
    | '/timesheet/admin'
    | '/timesheet/approval'
    | '/timesheet/by-project'
    | '/timesheet/new'
    | '/timesheet/reasons'
    | '/users/$userId'
    | '/users/new'
    | '/warehouse/attributes'
    | '/warehouse/documents'
    | '/warehouse/inventory'
    | '/warehouse/items'
    | '/warehouse/locations'
    | '/warehouse/lots'
    | '/warehouse/warehouses'
    | '/workforce/$employeeId'
    | '/workforce/bu'
    | '/workforce/dashboard'
    | '/workforce/external'
    | '/workforce/hierarchy'
    | '/workforce/roles'
    | '/workforce/site-presences'
    | '/workforce/today'
    | '/workforce/training'
    | '/portal/$modulo'
    | '/portal/assistenza'
    | '/portal/attivita'
    | '/portal/azienda'
    | '/portal/circulars'
    | '/portal/commesse'
    | '/portal/documenti'
    | '/portal/fatture'
    | '/portal/numeri'
    | '/portal/ordini'
    | '/portal/profilo'
    | '/portal/verbali'
    | '/terms/$code'
    | '/circulars/'
    | '/clients/'
    | '/foodcost/'
    | '/instruments-calendar/'
    | '/leave/'
    | '/notifications/'
    | '/orders/'
    | '/planning/'
    | '/projects/'
    | '/roles/'
    | '/settings/'
    | '/smart-working/'
    | '/tasks/'
    | '/templates/'
    | '/test-plans/'
    | '/timesheet/'
    | '/users/'
    | '/warehouse/'
    | '/workforce/'
    | '/portal/'
    | '/admin/tenants/$tenantId'
    | '/admin/tenants/group'
    | '/foodcost/portale/$clienteId'
    | '/foodcost/scheda/$periodoId'
    | '/projects/$projectId/dashboard'
    | '/workforce/sites/$siteId'
    | '/admin/tenants/'
    | '/workforce/sites/'
    | '/admin/tenants/$tenantId/subscription'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/app-android'
    | '/approvals'
    | '/articles'
    | '/attendance'
    | '/billing'
    | '/car-history'
    | '/changelog'
    | '/configuration'
    | '/developer-guide'
    | '/expense-reports'
    | '/fleet'
    | '/general-crud'
    | '/group-rules'
    | '/help'
    | '/insights'
    | '/intercompany'
    | '/legal-notices'
    | '/legals'
    | '/licensing'
    | '/maeworld'
    | '/media'
    | '/my-subscriptions'
    | '/my-vehicles'
    | '/my-violations'
    | '/notes'
    | '/onboarding'
    | '/open-app'
    | '/products'
    | '/project-forecast'
    | '/quality'
    | '/reporting'
    | '/service-reports'
    | '/setup'
    | '/shift-swaps'
    | '/sprint'
    | '/statistics'
    | '/support'
    | '/support-intake'
    | '/switch-tenant'
    | '/team-calendar'
    | '/team-deadlines'
    | '/test-cases'
    | '/test-coverage'
    | '/tickets'
    | '/translate-structure'
    | '/translations'
    | '/travel'
    | '/update-app'
    | '/upload-attachments'
    | '/user-audit'
    | '/user-guide'
    | '/vehicle-bookings'
    | '/vehicles'
    | '/access-permissions'
    | '/login'
    | '/password-reset'
    | '/recovery-password'
    | '/register'
    | '/register-otp'
    | '/select-tenant'
    | '/update-password'
    | '/download-app'
    | '/help-desk-unlog'
    | '/maintenance'
    | '/tenant-fallback'
    | '/admin/attendance-reminders'
    | '/admin/attendance-sources'
    | '/admin/audit-log'
    | '/admin/board-config'
    | '/admin/branding'
    | '/admin/categories'
    | '/admin/client-intake'
    | '/admin/connectors'
    | '/admin/cross-tenant-access-logs'
    | '/admin/email-log'
    | '/admin/jobs'
    | '/admin/leave-config'
    | '/admin/license-dashboard'
    | '/admin/license-plans'
    | '/admin/licenses-catalog'
    | '/admin/logs'
    | '/admin/maintenance'
    | '/admin/mcp-connections'
    | '/admin/mileage-rates'
    | '/admin/modules'
    | '/admin/planning-policies'
    | '/admin/policies'
    | '/admin/portal-documents'
    | '/admin/portal-pages'
    | '/admin/project-attribute-definitions'
    | '/admin/project-categories'
    | '/admin/project-type-presets'
    | '/admin/protected-statuses'
    | '/admin/send-communications'
    | '/admin/smart-working-config'
    | '/admin/structure-labels'
    | '/admin/subscription-types'
    | '/admin/support-topics'
    | '/admin/system'
    | '/admin/tardiness-policies'
    | '/admin/task-labels'
    | '/admin/task-rules'
    | '/admin/tenant-attributes'
    | '/admin/tenant-management'
    | '/admin/tenant-users'
    | '/admin/translate-structure'
    | '/admin/travel-policies'
    | '/admin/workflows'
    | '/articles/$id'
    | '/attendance/team-month'
    | '/bookings/car-history'
    | '/bookings/new'
    | '/circulars/register'
    | '/circulars/release-notes'
    | '/clients/$clientId'
    | '/foodcost/$periodoId'
    | '/foodcost/cluster'
    | '/foodcost/indicatori'
    | '/foodcost/mappature'
    | '/foodcost/schema'
    | '/foodcost/solleciti'
    | '/insights/monthly-invoices'
    | '/insights/subscriptions'
    | '/instruments-calendar/approvals'
    | '/leave/approvals'
    | '/leave/new'
    | '/mcp/authorize'
    | '/notifications/$notificationId'
    | '/orders/$orderId'
    | '/organization/company'
    | '/organization/company-data'
    | '/organization/employees'
    | '/organization/permissions'
    | '/organization/work-rules'
    | '/organization/work-shifts'
    | '/planning/new'
    | '/projects/$projectId'
    | '/projects/gantt'
    | '/projects/new'
    | '/projects/wbs'
    | '/roles/$roleId'
    | '/secretary/area'
    | '/settings/api-keys'
    | '/settings/devices'
    | '/settings/integrations'
    | '/settings/notification-preferences'
    | '/settings/preferences'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/protected-data'
    | '/settings/security'
    | '/smart-working/approvals'
    | '/tasks/$taskId'
    | '/tasks/capacity'
    | '/tasks/card'
    | '/tasks/dashboard'
    | '/tasks/gantt'
    | '/tasks/gantt-interactive'
    | '/tasks/kanban'
    | '/tasks/list'
    | '/tasks/new'
    | '/tasks/notes'
    | '/tasks/plan'
    | '/tasks/wbs'
    | '/templates/$templateId'
    | '/test-plans/$planId'
    | '/timesheet/admin'
    | '/timesheet/approval'
    | '/timesheet/by-project'
    | '/timesheet/new'
    | '/timesheet/reasons'
    | '/users/$userId'
    | '/users/new'
    | '/warehouse/attributes'
    | '/warehouse/documents'
    | '/warehouse/inventory'
    | '/warehouse/items'
    | '/warehouse/locations'
    | '/warehouse/lots'
    | '/warehouse/warehouses'
    | '/workforce/$employeeId'
    | '/workforce/bu'
    | '/workforce/dashboard'
    | '/workforce/external'
    | '/workforce/hierarchy'
    | '/workforce/roles'
    | '/workforce/site-presences'
    | '/workforce/today'
    | '/workforce/training'
    | '/portal/$modulo'
    | '/portal/assistenza'
    | '/portal/attivita'
    | '/portal/azienda'
    | '/portal/circulars'
    | '/portal/commesse'
    | '/portal/documenti'
    | '/portal/fatture'
    | '/portal/numeri'
    | '/portal/ordini'
    | '/portal/profilo'
    | '/portal/verbali'
    | '/terms/$code'
    | '/circulars'
    | '/clients'
    | '/foodcost'
    | '/instruments-calendar'
    | '/leave'
    | '/notifications'
    | '/orders'
    | '/planning'
    | '/projects'
    | '/roles'
    | '/settings'
    | '/smart-working'
    | '/tasks'
    | '/templates'
    | '/test-plans'
    | '/timesheet'
    | '/users'
    | '/warehouse'
    | '/workforce'
    | '/portal'
    | '/admin/tenants/$tenantId'
    | '/admin/tenants/group'
    | '/foodcost/portale/$clienteId'
    | '/foodcost/scheda/$periodoId'
    | '/projects/$projectId/dashboard'
    | '/workforce/sites/$siteId'
    | '/admin/tenants'
    | '/workforce/sites'
    | '/admin/tenants/$tenantId/subscription'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_portal'
    | '/_public'
    | '/_app/projects'
    | '/_app/roles'
    | '/_app/settings'
    | '/_app/templates'
    | '/_app/timesheet'
    | '/_app/users'
    | '/_app/warehouse'
    | '/_app/workforce'
    | '/_app/about'
    | '/_app/app-android'
    | '/_app/approvals'
    | '/_app/articles'
    | '/_app/attendance'
    | '/_app/billing'
    | '/_app/car-history'
    | '/_app/changelog'
    | '/_app/configuration'
    | '/_app/developer-guide'
    | '/_app/expense-reports'
    | '/_app/fleet'
    | '/_app/general-crud'
    | '/_app/group-rules'
    | '/_app/help'
    | '/_app/insights'
    | '/_app/instruments-calendar'
    | '/_app/intercompany'
    | '/_app/leave'
    | '/_app/legal-notices'
    | '/_app/legals'
    | '/_app/licensing'
    | '/_app/maeworld'
    | '/_app/media'
    | '/_app/my-subscriptions'
    | '/_app/my-vehicles'
    | '/_app/my-violations'
    | '/_app/notes'
    | '/_app/notifications'
    | '/_app/onboarding'
    | '/_app/open-app'
    | '/_app/planning'
    | '/_app/products'
    | '/_app/project-forecast'
    | '/_app/quality'
    | '/_app/reporting'
    | '/_app/service-reports'
    | '/_app/setup'
    | '/_app/shift-swaps'
    | '/_app/smart-working'
    | '/_app/sprint'
    | '/_app/statistics'
    | '/_app/support'
    | '/_app/support-intake'
    | '/_app/switch-tenant'
    | '/_app/tasks'
    | '/_app/team-calendar'
    | '/_app/team-deadlines'
    | '/_app/test-cases'
    | '/_app/test-coverage'
    | '/_app/test-plans'
    | '/_app/tickets'
    | '/_app/translate-structure'
    | '/_app/translations'
    | '/_app/travel'
    | '/_app/update-app'
    | '/_app/upload-attachments'
    | '/_app/user-audit'
    | '/_app/user-guide'
    | '/_app/vehicle-bookings'
    | '/_app/vehicles'
    | '/_auth/access-permissions'
    | '/_auth/login'
    | '/_auth/password-reset'
    | '/_auth/recovery-password'
    | '/_auth/register'
    | '/_auth/register-otp'
    | '/_auth/select-tenant'
    | '/_auth/update-password'
    | '/_public/download-app'
    | '/_public/help-desk-unlog'
    | '/_public/maintenance'
    | '/_public/tenant-fallback'
    | '/_app/'
    | '/_app/admin/attendance-reminders'
    | '/_app/admin/attendance-sources'
    | '/_app/admin/audit-log'
    | '/_app/admin/board-config'
    | '/_app/admin/branding'
    | '/_app/admin/categories'
    | '/_app/admin/client-intake'
    | '/_app/admin/connectors'
    | '/_app/admin/cross-tenant-access-logs'
    | '/_app/admin/email-log'
    | '/_app/admin/jobs'
    | '/_app/admin/leave-config'
    | '/_app/admin/license-dashboard'
    | '/_app/admin/license-plans'
    | '/_app/admin/licenses-catalog'
    | '/_app/admin/logs'
    | '/_app/admin/maintenance'
    | '/_app/admin/mcp-connections'
    | '/_app/admin/mileage-rates'
    | '/_app/admin/modules'
    | '/_app/admin/planning-policies'
    | '/_app/admin/policies'
    | '/_app/admin/portal-documents'
    | '/_app/admin/portal-pages'
    | '/_app/admin/project-attribute-definitions'
    | '/_app/admin/project-categories'
    | '/_app/admin/project-type-presets'
    | '/_app/admin/protected-statuses'
    | '/_app/admin/send-communications'
    | '/_app/admin/smart-working-config'
    | '/_app/admin/structure-labels'
    | '/_app/admin/subscription-types'
    | '/_app/admin/support-topics'
    | '/_app/admin/system'
    | '/_app/admin/tardiness-policies'
    | '/_app/admin/task-labels'
    | '/_app/admin/task-rules'
    | '/_app/admin/tenant-attributes'
    | '/_app/admin/tenant-management'
    | '/_app/admin/tenant-users'
    | '/_app/admin/translate-structure'
    | '/_app/admin/travel-policies'
    | '/_app/admin/workflows'
    | '/_app/articles_/$id'
    | '/_app/attendance_/team-month'
    | '/_app/bookings/car-history'
    | '/_app/bookings/new'
    | '/_app/circulars/register'
    | '/_app/circulars/release-notes'
    | '/_app/clients/$clientId'
    | '/_app/foodcost/$periodoId'
    | '/_app/foodcost/cluster'
    | '/_app/foodcost/indicatori'
    | '/_app/foodcost/mappature'
    | '/_app/foodcost/schema'
    | '/_app/foodcost/solleciti'
    | '/_app/insights/monthly-invoices'
    | '/_app/insights/subscriptions'
    | '/_app/instruments-calendar/approvals'
    | '/_app/leave/approvals'
    | '/_app/leave/new'
    | '/_app/mcp/authorize'
    | '/_app/notifications/$notificationId'
    | '/_app/orders/$orderId'
    | '/_app/organization/company'
    | '/_app/organization/company-data'
    | '/_app/organization/employees'
    | '/_app/organization/permissions'
    | '/_app/organization/work-rules'
    | '/_app/organization/work-shifts'
    | '/_app/planning/new'
    | '/_app/projects/$projectId'
    | '/_app/projects/gantt'
    | '/_app/projects/new'
    | '/_app/projects/wbs'
    | '/_app/roles/$roleId'
    | '/_app/secretary/area'
    | '/_app/settings/api-keys'
    | '/_app/settings/devices'
    | '/_app/settings/integrations'
    | '/_app/settings/notification-preferences'
    | '/_app/settings/preferences'
    | '/_app/settings/privacy'
    | '/_app/settings/profile'
    | '/_app/settings/protected-data'
    | '/_app/settings/security'
    | '/_app/smart-working/approvals'
    | '/_app/tasks/$taskId'
    | '/_app/tasks/capacity'
    | '/_app/tasks/card'
    | '/_app/tasks/dashboard'
    | '/_app/tasks/gantt'
    | '/_app/tasks/gantt-interactive'
    | '/_app/tasks/kanban'
    | '/_app/tasks/list'
    | '/_app/tasks/new'
    | '/_app/tasks/notes'
    | '/_app/tasks/plan'
    | '/_app/tasks/wbs'
    | '/_app/templates/$templateId'
    | '/_app/test-plans/$planId'
    | '/_app/timesheet/admin'
    | '/_app/timesheet/approval'
    | '/_app/timesheet/by-project'
    | '/_app/timesheet/new'
    | '/_app/timesheet/reasons'
    | '/_app/users/$userId'
    | '/_app/users/new'
    | '/_app/warehouse/attributes'
    | '/_app/warehouse/documents'
    | '/_app/warehouse/inventory'
    | '/_app/warehouse/items'
    | '/_app/warehouse/locations'
    | '/_app/warehouse/lots'
    | '/_app/warehouse/warehouses'
    | '/_app/workforce/$employeeId'
    | '/_app/workforce/bu'
    | '/_app/workforce/dashboard'
    | '/_app/workforce/external'
    | '/_app/workforce/hierarchy'
    | '/_app/workforce/roles'
    | '/_app/workforce/site-presences'
    | '/_app/workforce/today'
    | '/_app/workforce/training'
    | '/_portal/portal/$modulo'
    | '/_portal/portal/assistenza'
    | '/_portal/portal/attivita'
    | '/_portal/portal/azienda'
    | '/_portal/portal/circulars'
    | '/_portal/portal/commesse'
    | '/_portal/portal/documenti'
    | '/_portal/portal/fatture'
    | '/_portal/portal/numeri'
    | '/_portal/portal/ordini'
    | '/_portal/portal/profilo'
    | '/_portal/portal/verbali'
    | '/_public/terms/$code'
    | '/_app/circulars/'
    | '/_app/clients/'
    | '/_app/foodcost/'
    | '/_app/instruments-calendar/'
    | '/_app/leave/'
    | '/_app/notifications/'
    | '/_app/orders/'
    | '/_app/planning/'
    | '/_app/projects/'
    | '/_app/roles/'
    | '/_app/settings/'
    | '/_app/smart-working/'
    | '/_app/tasks/'
    | '/_app/templates/'
    | '/_app/test-plans/'
    | '/_app/timesheet/'
    | '/_app/users/'
    | '/_app/warehouse/'
    | '/_app/workforce/'
    | '/_portal/portal/'
    | '/_app/admin/tenants/$tenantId'
    | '/_app/admin/tenants/group'
    | '/_app/foodcost/portale/$clienteId'
    | '/_app/foodcost/scheda/$periodoId'
    | '/_app/projects/$projectId/dashboard'
    | '/_app/workforce/sites/$siteId'
    | '/_app/admin/tenants/'
    | '/_app/workforce/sites/'
    | '/_app/admin/tenants/$tenantId/subscription'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  PortalRoute: typeof PortalRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_portal': {
      id: '/_portal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/tenant-fallback': {
      id: '/_public/tenant-fallback'
      path: '/tenant-fallback'
      fullPath: '/tenant-fallback'
      preLoaderRoute: typeof PublicTenantFallbackRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/maintenance': {
      id: '/_public/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof PublicMaintenanceRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/help-desk-unlog': {
      id: '/_public/help-desk-unlog'
      path: '/help-desk-unlog'
      fullPath: '/help-desk-unlog'
      preLoaderRoute: typeof PublicHelpDeskUnlogRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/download-app': {
      id: '/_public/download-app'
      path: '/download-app'
      fullPath: '/download-app'
      preLoaderRoute: typeof PublicDownloadAppRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/update-password': {
      id: '/_auth/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof AuthUpdatePasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/select-tenant': {
      id: '/_auth/select-tenant'
      path: '/select-tenant'
      fullPath: '/select-tenant'
      preLoaderRoute: typeof AuthSelectTenantRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register-otp': {
      id: '/_auth/register-otp'
      path: '/register-otp'
      fullPath: '/register-otp'
      preLoaderRoute: typeof AuthRegisterOtpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recovery-password': {
      id: '/_auth/recovery-password'
      path: '/recovery-password'
      fullPath: '/recovery-password'
      preLoaderRoute: typeof AuthRecoveryPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/password-reset': {
      id: '/_auth/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof AuthPasswordResetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/access-permissions': {
      id: '/_auth/access-permissions'
      path: '/access-permissions'
      fullPath: '/access-permissions'
      preLoaderRoute: typeof AuthAccessPermissionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/vehicles': {
      id: '/_app/vehicles'
      path: '/vehicles'
      fullPath: '/vehicles'
      preLoaderRoute: typeof AppVehiclesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vehicle-bookings': {
      id: '/_app/vehicle-bookings'
      path: '/vehicle-bookings'
      fullPath: '/vehicle-bookings'
      preLoaderRoute: typeof AppVehicleBookingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/user-guide': {
      id: '/_app/user-guide'
      path: '/user-guide'
      fullPath: '/user-guide'
      preLoaderRoute: typeof AppUserGuideRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/user-audit': {
      id: '/_app/user-audit'
      path: '/user-audit'
      fullPath: '/user-audit'
      preLoaderRoute: typeof AppUserAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/upload-attachments': {
      id: '/_app/upload-attachments'
      path: '/upload-attachments'
      fullPath: '/upload-attachments'
      preLoaderRoute: typeof AppUploadAttachmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/update-app': {
      id: '/_app/update-app'
      path: '/update-app'
      fullPath: '/update-app'
      preLoaderRoute: typeof AppUpdateAppRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/travel': {
      id: '/_app/travel'
      path: '/travel'
      fullPath: '/travel'
      preLoaderRoute: typeof AppTravelRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/translations': {
      id: '/_app/translations'
      path: '/translations'
      fullPath: '/translations'
      preLoaderRoute: typeof AppTranslationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/translate-structure': {
      id: '/_app/translate-structure'
      path: '/translate-structure'
      fullPath: '/translate-structure'
      preLoaderRoute: typeof AppTranslateStructureRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets': {
      id: '/_app/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AppTicketsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/test-plans': {
      id: '/_app/test-plans'
      path: '/test-plans'
      fullPath: '/test-plans'
      preLoaderRoute: typeof AppTestPlansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/test-coverage': {
      id: '/_app/test-coverage'
      path: '/test-coverage'
      fullPath: '/test-coverage'
      preLoaderRoute: typeof AppTestCoverageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/test-cases': {
      id: '/_app/test-cases'
      path: '/test-cases'
      fullPath: '/test-cases'
      preLoaderRoute: typeof AppTestCasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team-deadlines': {
      id: '/_app/team-deadlines'
      path: '/team-deadlines'
      fullPath: '/team-deadlines'
      preLoaderRoute: typeof AppTeamDeadlinesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team-calendar': {
      id: '/_app/team-calendar'
      path: '/team-calendar'
      fullPath: '/team-calendar'
      preLoaderRoute: typeof AppTeamCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/switch-tenant': {
      id: '/_app/switch-tenant'
      path: '/switch-tenant'
      fullPath: '/switch-tenant'
      preLoaderRoute: typeof AppSwitchTenantRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support-intake': {
      id: '/_app/support-intake'
      path: '/support-intake'
      fullPath: '/support-intake'
      preLoaderRoute: typeof AppSupportIntakeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support': {
      id: '/_app/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AppSupportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/statistics': {
      id: '/_app/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AppStatisticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sprint': {
      id: '/_app/sprint'
      path: '/sprint'
      fullPath: '/sprint'
      preLoaderRoute: typeof AppSprintRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/smart-working': {
      id: '/_app/smart-working'
      path: '/smart-working'
      fullPath: '/smart-working'
      preLoaderRoute: typeof AppSmartWorkingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shift-swaps': {
      id: '/_app/shift-swaps'
      path: '/shift-swaps'
      fullPath: '/shift-swaps'
      preLoaderRoute: typeof AppShiftSwapsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/setup': {
      id: '/_app/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AppSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service-reports': {
      id: '/_app/service-reports'
      path: '/service-reports'
      fullPath: '/service-reports'
      preLoaderRoute: typeof AppServiceReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reporting': {
      id: '/_app/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof AppReportingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quality': {
      id: '/_app/quality'
      path: '/quality'
      fullPath: '/quality'
      preLoaderRoute: typeof AppQualityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/project-forecast': {
      id: '/_app/project-forecast'
      path: '/project-forecast'
      fullPath: '/project-forecast'
      preLoaderRoute: typeof AppProjectForecastRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/planning': {
      id: '/_app/planning'
      path: '/planning'
      fullPath: '/planning'
      preLoaderRoute: typeof AppPlanningRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/open-app': {
      id: '/_app/open-app'
      path: '/open-app'
      fullPath: '/open-app'
      preLoaderRoute: typeof AppOpenAppRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding': {
      id: '/_app/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notes': {
      id: '/_app/notes'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof AppNotesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-violations': {
      id: '/_app/my-violations'
      path: '/my-violations'
      fullPath: '/my-violations'
      preLoaderRoute: typeof AppMyViolationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-vehicles': {
      id: '/_app/my-vehicles'
      path: '/my-vehicles'
      fullPath: '/my-vehicles'
      preLoaderRoute: typeof AppMyVehiclesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-subscriptions': {
      id: '/_app/my-subscriptions'
      path: '/my-subscriptions'
      fullPath: '/my-subscriptions'
      preLoaderRoute: typeof AppMySubscriptionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/media': {
      id: '/_app/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof AppMediaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maeworld': {
      id: '/_app/maeworld'
      path: '/maeworld'
      fullPath: '/maeworld'
      preLoaderRoute: typeof AppMaeworldRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/licensing': {
      id: '/_app/licensing'
      path: '/licensing'
      fullPath: '/licensing'
      preLoaderRoute: typeof AppLicensingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/legals': {
      id: '/_app/legals'
      path: '/legals'
      fullPath: '/legals'
      preLoaderRoute: typeof AppLegalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/legal-notices': {
      id: '/_app/legal-notices'
      path: '/legal-notices'
      fullPath: '/legal-notices'
      preLoaderRoute: typeof AppLegalNoticesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leave': {
      id: '/_app/leave'
      path: '/leave'
      fullPath: '/leave'
      preLoaderRoute: typeof AppLeaveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/intercompany': {
      id: '/_app/intercompany'
      path: '/intercompany'
      fullPath: '/intercompany'
      preLoaderRoute: typeof AppIntercompanyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/instruments-calendar': {
      id: '/_app/instruments-calendar'
      path: '/instruments-calendar'
      fullPath: '/instruments-calendar'
      preLoaderRoute: typeof AppInstrumentsCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/insights': {
      id: '/_app/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AppInsightsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/group-rules': {
      id: '/_app/group-rules'
      path: '/group-rules'
      fullPath: '/group-rules'
      preLoaderRoute: typeof AppGroupRulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/general-crud': {
      id: '/_app/general-crud'
      path: '/general-crud'
      fullPath: '/general-crud'
      preLoaderRoute: typeof AppGeneralCrudRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fleet': {
      id: '/_app/fleet'
      path: '/fleet'
      fullPath: '/fleet'
      preLoaderRoute: typeof AppFleetRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/expense-reports': {
      id: '/_app/expense-reports'
      path: '/expense-reports'
      fullPath: '/expense-reports'
      preLoaderRoute: typeof AppExpenseReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developer-guide': {
      id: '/_app/developer-guide'
      path: '/developer-guide'
      fullPath: '/developer-guide'
      preLoaderRoute: typeof AppDeveloperGuideRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/configuration': {
      id: '/_app/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof AppConfigurationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/changelog': {
      id: '/_app/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof AppChangelogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/car-history': {
      id: '/_app/car-history'
      path: '/car-history'
      fullPath: '/car-history'
      preLoaderRoute: typeof AppCarHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing': {
      id: '/_app/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/attendance': {
      id: '/_app/attendance'
      path: '/attendance'
      fullPath: '/attendance'
      preLoaderRoute: typeof AppAttendanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/articles': {
      id: '/_app/articles'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof AppArticlesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals': {
      id: '/_app/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AppApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app-android': {
      id: '/_app/app-android'
      path: '/app-android'
      fullPath: '/app-android'
      preLoaderRoute: typeof AppAppAndroidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/about': {
      id: '/_app/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AppAboutRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workforce': {
      id: '/_app/workforce'
      path: '/workforce'
      fullPath: '/workforce'
      preLoaderRoute: typeof AppWorkforceRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehouse': {
      id: '/_app/warehouse'
      path: '/warehouse'
      fullPath: '/warehouse'
      preLoaderRoute: typeof AppWarehouseRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/timesheet': {
      id: '/_app/timesheet'
      path: '/timesheet'
      fullPath: '/timesheet'
      preLoaderRoute: typeof AppTimesheetRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/templates': {
      id: '/_app/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AppTemplatesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/roles': {
      id: '/_app/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AppRolesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects': {
      id: '/_app/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_portal/portal/': {
      id: '/_portal/portal/'
      path: '/portal'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalPortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_app/workforce/': {
      id: '/_app/workforce/'
      path: '/'
      fullPath: '/workforce/'
      preLoaderRoute: typeof AppWorkforceIndexRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/warehouse/': {
      id: '/_app/warehouse/'
      path: '/'
      fullPath: '/warehouse/'
      preLoaderRoute: typeof AppWarehouseIndexRouteImport
      parentRoute: typeof AppWarehouseRouteRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/timesheet/': {
      id: '/_app/timesheet/'
      path: '/'
      fullPath: '/timesheet/'
      preLoaderRoute: typeof AppTimesheetIndexRouteImport
      parentRoute: typeof AppTimesheetRouteRoute
    }
    '/_app/test-plans/': {
      id: '/_app/test-plans/'
      path: '/'
      fullPath: '/test-plans/'
      preLoaderRoute: typeof AppTestPlansIndexRouteImport
      parentRoute: typeof AppTestPlansRoute
    }
    '/_app/templates/': {
      id: '/_app/templates/'
      path: '/'
      fullPath: '/templates/'
      preLoaderRoute: typeof AppTemplatesIndexRouteImport
      parentRoute: typeof AppTemplatesRouteRoute
    }
    '/_app/tasks/': {
      id: '/_app/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/smart-working/': {
      id: '/_app/smart-working/'
      path: '/'
      fullPath: '/smart-working/'
      preLoaderRoute: typeof AppSmartWorkingIndexRouteImport
      parentRoute: typeof AppSmartWorkingRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/roles/': {
      id: '/_app/roles/'
      path: '/'
      fullPath: '/roles/'
      preLoaderRoute: typeof AppRolesIndexRouteImport
      parentRoute: typeof AppRolesRouteRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/planning/': {
      id: '/_app/planning/'
      path: '/'
      fullPath: '/planning/'
      preLoaderRoute: typeof AppPlanningIndexRouteImport
      parentRoute: typeof AppPlanningRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications/': {
      id: '/_app/notifications/'
      path: '/'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AppNotificationsIndexRouteImport
      parentRoute: typeof AppNotificationsRoute
    }
    '/_app/leave/': {
      id: '/_app/leave/'
      path: '/'
      fullPath: '/leave/'
      preLoaderRoute: typeof AppLeaveIndexRouteImport
      parentRoute: typeof AppLeaveRoute
    }
    '/_app/instruments-calendar/': {
      id: '/_app/instruments-calendar/'
      path: '/'
      fullPath: '/instruments-calendar/'
      preLoaderRoute: typeof AppInstrumentsCalendarIndexRouteImport
      parentRoute: typeof AppInstrumentsCalendarRoute
    }
    '/_app/foodcost/': {
      id: '/_app/foodcost/'
      path: '/foodcost'
      fullPath: '/foodcost/'
      preLoaderRoute: typeof AppFoodcostIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/circulars/': {
      id: '/_app/circulars/'
      path: '/circulars'
      fullPath: '/circulars/'
      preLoaderRoute: typeof AppCircularsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/terms/$code': {
      id: '/_public/terms/$code'
      path: '/terms/$code'
      fullPath: '/terms/$code'
      preLoaderRoute: typeof PublicTermsCodeRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_portal/portal/verbali': {
      id: '/_portal/portal/verbali'
      path: '/portal/verbali'
      fullPath: '/portal/verbali'
      preLoaderRoute: typeof PortalPortalVerbaliRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/profilo': {
      id: '/_portal/portal/profilo'
      path: '/portal/profilo'
      fullPath: '/portal/profilo'
      preLoaderRoute: typeof PortalPortalProfiloRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/ordini': {
      id: '/_portal/portal/ordini'
      path: '/portal/ordini'
      fullPath: '/portal/ordini'
      preLoaderRoute: typeof PortalPortalOrdiniRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/numeri': {
      id: '/_portal/portal/numeri'
      path: '/portal/numeri'
      fullPath: '/portal/numeri'
      preLoaderRoute: typeof PortalPortalNumeriRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/fatture': {
      id: '/_portal/portal/fatture'
      path: '/portal/fatture'
      fullPath: '/portal/fatture'
      preLoaderRoute: typeof PortalPortalFattureRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/documenti': {
      id: '/_portal/portal/documenti'
      path: '/portal/documenti'
      fullPath: '/portal/documenti'
      preLoaderRoute: typeof PortalPortalDocumentiRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/commesse': {
      id: '/_portal/portal/commesse'
      path: '/portal/commesse'
      fullPath: '/portal/commesse'
      preLoaderRoute: typeof PortalPortalCommesseRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/circulars': {
      id: '/_portal/portal/circulars'
      path: '/portal/circulars'
      fullPath: '/portal/circulars'
      preLoaderRoute: typeof PortalPortalCircularsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/azienda': {
      id: '/_portal/portal/azienda'
      path: '/portal/azienda'
      fullPath: '/portal/azienda'
      preLoaderRoute: typeof PortalPortalAziendaRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/attivita': {
      id: '/_portal/portal/attivita'
      path: '/portal/attivita'
      fullPath: '/portal/attivita'
      preLoaderRoute: typeof PortalPortalAttivitaRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/assistenza': {
      id: '/_portal/portal/assistenza'
      path: '/portal/assistenza'
      fullPath: '/portal/assistenza'
      preLoaderRoute: typeof PortalPortalAssistenzaRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/portal/$modulo': {
      id: '/_portal/portal/$modulo'
      path: '/portal/$modulo'
      fullPath: '/portal/$modulo'
      preLoaderRoute: typeof PortalPortalModuloRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_app/workforce/training': {
      id: '/_app/workforce/training'
      path: '/training'
      fullPath: '/workforce/training'
      preLoaderRoute: typeof AppWorkforceTrainingRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/today': {
      id: '/_app/workforce/today'
      path: '/today'
      fullPath: '/workforce/today'
      preLoaderRoute: typeof AppWorkforceTodayRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/site-presences': {
      id: '/_app/workforce/site-presences'
      path: '/site-presences'
      fullPath: '/workforce/site-presences'
      preLoaderRoute: typeof AppWorkforceSitePresencesRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/roles': {
      id: '/_app/workforce/roles'
      path: '/roles'
      fullPath: '/workforce/roles'
      preLoaderRoute: typeof AppWorkforceRolesRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/hierarchy': {
      id: '/_app/workforce/hierarchy'
      path: '/hierarchy'
      fullPath: '/workforce/hierarchy'
      preLoaderRoute: typeof AppWorkforceHierarchyRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/external': {
      id: '/_app/workforce/external'
      path: '/external'
      fullPath: '/workforce/external'
      preLoaderRoute: typeof AppWorkforceExternalRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/dashboard': {
      id: '/_app/workforce/dashboard'
      path: '/dashboard'
      fullPath: '/workforce/dashboard'
      preLoaderRoute: typeof AppWorkforceDashboardRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/bu': {
      id: '/_app/workforce/bu'
      path: '/bu'
      fullPath: '/workforce/bu'
      preLoaderRoute: typeof AppWorkforceBuRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/$employeeId': {
      id: '/_app/workforce/$employeeId'
      path: '/$employeeId'
      fullPath: '/workforce/$employeeId'
      preLoaderRoute: typeof AppWorkforceEmployeeIdRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/warehouse/warehouses': {
      id: '/_app/warehouse/warehouses'
      path: '/warehouses'
      fullPath: '/warehouse/warehouses'
      preLoaderRoute: typeof AppWarehouseWarehousesRouteImport
      parentRoute: typeof AppWarehouseRouteRoute
    }
    '/_app/warehouse/lots': {
      id: '/_app/warehouse/lots'
      path: '/lots'
      fullPath: '/warehouse/lots'
      preLoaderRoute: typeof AppWarehouseLotsRouteImport
      parentRoute: typeof AppWarehouseRouteRoute
    }
    '/_app/warehouse/locations': {
      id: '/_app/warehouse/locations'
      path: '/locations'
      fullPath: '/warehouse/locations'
      preLoaderRoute: typeof AppWarehouseLocationsRouteImport
      parentRoute: typeof AppWarehouseRouteRoute
    }
    '/_app/warehouse/items': {
      id: '/_app/warehouse/items'
      path: '/items'
      fullPath: '/warehouse/items'
      preLoaderRoute: typeof AppWarehouseItemsRouteImport
      parentRoute: typeof AppWarehouseRouteRoute
    }
    '/_app/warehouse/inventory': {
      id: '/_app/warehouse/inventory'
      path: '/inventory'
      fullPath: '/warehouse/inventory'
      preLoaderRoute: typeof AppWarehouseInventoryRouteImport
      parentRoute: typeof AppWarehouseRouteRoute
    }
    '/_app/warehouse/documents': {
      id: '/_app/warehouse/documents'
      path: '/documents'
      fullPath: '/warehouse/documents'
      preLoaderRoute: typeof AppWarehouseDocumentsRouteImport
      parentRoute: typeof AppWarehouseRouteRoute
    }
    '/_app/warehouse/attributes': {
      id: '/_app/warehouse/attributes'
      path: '/attributes'
      fullPath: '/warehouse/attributes'
      preLoaderRoute: typeof AppWarehouseAttributesRouteImport
      parentRoute: typeof AppWarehouseRouteRoute
    }
    '/_app/users/new': {
      id: '/_app/users/new'
      path: '/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof AppUsersNewRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/$userId': {
      id: '/_app/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AppUsersUserIdRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/timesheet/reasons': {
      id: '/_app/timesheet/reasons'
      path: '/reasons'
      fullPath: '/timesheet/reasons'
      preLoaderRoute: typeof AppTimesheetReasonsRouteImport
      parentRoute: typeof AppTimesheetRouteRoute
    }
    '/_app/timesheet/new': {
      id: '/_app/timesheet/new'
      path: '/new'
      fullPath: '/timesheet/new'
      preLoaderRoute: typeof AppTimesheetNewRouteImport
      parentRoute: typeof AppTimesheetRouteRoute
    }
    '/_app/timesheet/by-project': {
      id: '/_app/timesheet/by-project'
      path: '/by-project'
      fullPath: '/timesheet/by-project'
      preLoaderRoute: typeof AppTimesheetByProjectRouteImport
      parentRoute: typeof AppTimesheetRouteRoute
    }
    '/_app/timesheet/approval': {
      id: '/_app/timesheet/approval'
      path: '/approval'
      fullPath: '/timesheet/approval'
      preLoaderRoute: typeof AppTimesheetApprovalRouteImport
      parentRoute: typeof AppTimesheetRouteRoute
    }
    '/_app/timesheet/admin': {
      id: '/_app/timesheet/admin'
      path: '/admin'
      fullPath: '/timesheet/admin'
      preLoaderRoute: typeof AppTimesheetAdminRouteImport
      parentRoute: typeof AppTimesheetRouteRoute
    }
    '/_app/test-plans/$planId': {
      id: '/_app/test-plans/$planId'
      path: '/$planId'
      fullPath: '/test-plans/$planId'
      preLoaderRoute: typeof AppTestPlansPlanIdRouteImport
      parentRoute: typeof AppTestPlansRoute
    }
    '/_app/templates/$templateId': {
      id: '/_app/templates/$templateId'
      path: '/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof AppTemplatesTemplateIdRouteImport
      parentRoute: typeof AppTemplatesRouteRoute
    }
    '/_app/tasks/wbs': {
      id: '/_app/tasks/wbs'
      path: '/wbs'
      fullPath: '/tasks/wbs'
      preLoaderRoute: typeof AppTasksWbsRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/plan': {
      id: '/_app/tasks/plan'
      path: '/plan'
      fullPath: '/tasks/plan'
      preLoaderRoute: typeof AppTasksPlanRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/notes': {
      id: '/_app/tasks/notes'
      path: '/notes'
      fullPath: '/tasks/notes'
      preLoaderRoute: typeof AppTasksNotesRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/new': {
      id: '/_app/tasks/new'
      path: '/new'
      fullPath: '/tasks/new'
      preLoaderRoute: typeof AppTasksNewRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/list': {
      id: '/_app/tasks/list'
      path: '/list'
      fullPath: '/tasks/list'
      preLoaderRoute: typeof AppTasksListRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/kanban': {
      id: '/_app/tasks/kanban'
      path: '/kanban'
      fullPath: '/tasks/kanban'
      preLoaderRoute: typeof AppTasksKanbanRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/gantt-interactive': {
      id: '/_app/tasks/gantt-interactive'
      path: '/gantt-interactive'
      fullPath: '/tasks/gantt-interactive'
      preLoaderRoute: typeof AppTasksGanttInteractiveRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/gantt': {
      id: '/_app/tasks/gantt'
      path: '/gantt'
      fullPath: '/tasks/gantt'
      preLoaderRoute: typeof AppTasksGanttRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/dashboard': {
      id: '/_app/tasks/dashboard'
      path: '/dashboard'
      fullPath: '/tasks/dashboard'
      preLoaderRoute: typeof AppTasksDashboardRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/card': {
      id: '/_app/tasks/card'
      path: '/card'
      fullPath: '/tasks/card'
      preLoaderRoute: typeof AppTasksCardRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/capacity': {
      id: '/_app/tasks/capacity'
      path: '/capacity'
      fullPath: '/tasks/capacity'
      preLoaderRoute: typeof AppTasksCapacityRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/$taskId': {
      id: '/_app/tasks/$taskId'
      path: '/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof AppTasksTaskIdRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/smart-working/approvals': {
      id: '/_app/smart-working/approvals'
      path: '/approvals'
      fullPath: '/smart-working/approvals'
      preLoaderRoute: typeof AppSmartWorkingApprovalsRouteImport
      parentRoute: typeof AppSmartWorkingRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/protected-data': {
      id: '/_app/settings/protected-data'
      path: '/protected-data'
      fullPath: '/settings/protected-data'
      preLoaderRoute: typeof AppSettingsProtectedDataRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/privacy': {
      id: '/_app/settings/privacy'
      path: '/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof AppSettingsPrivacyRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/preferences': {
      id: '/_app/settings/preferences'
      path: '/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof AppSettingsPreferencesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/notification-preferences': {
      id: '/_app/settings/notification-preferences'
      path: '/notification-preferences'
      fullPath: '/settings/notification-preferences'
      preLoaderRoute: typeof AppSettingsNotificationPreferencesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/devices': {
      id: '/_app/settings/devices'
      path: '/devices'
      fullPath: '/settings/devices'
      preLoaderRoute: typeof AppSettingsDevicesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/api-keys': {
      id: '/_app/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AppSettingsApiKeysRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/secretary/area': {
      id: '/_app/secretary/area'
      path: '/secretary/area'
      fullPath: '/secretary/area'
      preLoaderRoute: typeof AppSecretaryAreaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/roles/$roleId': {
      id: '/_app/roles/$roleId'
      path: '/$roleId'
      fullPath: '/roles/$roleId'
      preLoaderRoute: typeof AppRolesRoleIdRouteImport
      parentRoute: typeof AppRolesRouteRoute
    }
    '/_app/projects/wbs': {
      id: '/_app/projects/wbs'
      path: '/wbs'
      fullPath: '/projects/wbs'
      preLoaderRoute: typeof AppProjectsWbsRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/new': {
      id: '/_app/projects/new'
      path: '/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof AppProjectsNewRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/gantt': {
      id: '/_app/projects/gantt'
      path: '/gantt'
      fullPath: '/projects/gantt'
      preLoaderRoute: typeof AppProjectsGanttRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/planning/new': {
      id: '/_app/planning/new'
      path: '/new'
      fullPath: '/planning/new'
      preLoaderRoute: typeof AppPlanningNewRouteImport
      parentRoute: typeof AppPlanningRoute
    }
    '/_app/organization/work-shifts': {
      id: '/_app/organization/work-shifts'
      path: '/organization/work-shifts'
      fullPath: '/organization/work-shifts'
      preLoaderRoute: typeof AppOrganizationWorkShiftsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organization/work-rules': {
      id: '/_app/organization/work-rules'
      path: '/organization/work-rules'
      fullPath: '/organization/work-rules'
      preLoaderRoute: typeof AppOrganizationWorkRulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organization/permissions': {
      id: '/_app/organization/permissions'
      path: '/organization/permissions'
      fullPath: '/organization/permissions'
      preLoaderRoute: typeof AppOrganizationPermissionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organization/employees': {
      id: '/_app/organization/employees'
      path: '/organization/employees'
      fullPath: '/organization/employees'
      preLoaderRoute: typeof AppOrganizationEmployeesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organization/company-data': {
      id: '/_app/organization/company-data'
      path: '/organization/company-data'
      fullPath: '/organization/company-data'
      preLoaderRoute: typeof AppOrganizationCompanyDataRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organization/company': {
      id: '/_app/organization/company'
      path: '/organization/company'
      fullPath: '/organization/company'
      preLoaderRoute: typeof AppOrganizationCompanyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$orderId': {
      id: '/_app/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AppOrdersOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications/$notificationId': {
      id: '/_app/notifications/$notificationId'
      path: '/$notificationId'
      fullPath: '/notifications/$notificationId'
      preLoaderRoute: typeof AppNotificationsNotificationIdRouteImport
      parentRoute: typeof AppNotificationsRoute
    }
    '/_app/mcp/authorize': {
      id: '/_app/mcp/authorize'
      path: '/mcp/authorize'
      fullPath: '/mcp/authorize'
      preLoaderRoute: typeof AppMcpAuthorizeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leave/new': {
      id: '/_app/leave/new'
      path: '/new'
      fullPath: '/leave/new'
      preLoaderRoute: typeof AppLeaveNewRouteImport
      parentRoute: typeof AppLeaveRoute
    }
    '/_app/leave/approvals': {
      id: '/_app/leave/approvals'
      path: '/approvals'
      fullPath: '/leave/approvals'
      preLoaderRoute: typeof AppLeaveApprovalsRouteImport
      parentRoute: typeof AppLeaveRoute
    }
    '/_app/instruments-calendar/approvals': {
      id: '/_app/instruments-calendar/approvals'
      path: '/approvals'
      fullPath: '/instruments-calendar/approvals'
      preLoaderRoute: typeof AppInstrumentsCalendarApprovalsRouteImport
      parentRoute: typeof AppInstrumentsCalendarRoute
    }
    '/_app/insights/subscriptions': {
      id: '/_app/insights/subscriptions'
      path: '/subscriptions'
      fullPath: '/insights/subscriptions'
      preLoaderRoute: typeof AppInsightsSubscriptionsRouteImport
      parentRoute: typeof AppInsightsRoute
    }
    '/_app/insights/monthly-invoices': {
      id: '/_app/insights/monthly-invoices'
      path: '/monthly-invoices'
      fullPath: '/insights/monthly-invoices'
      preLoaderRoute: typeof AppInsightsMonthlyInvoicesRouteImport
      parentRoute: typeof AppInsightsRoute
    }
    '/_app/foodcost/solleciti': {
      id: '/_app/foodcost/solleciti'
      path: '/foodcost/solleciti'
      fullPath: '/foodcost/solleciti'
      preLoaderRoute: typeof AppFoodcostSollecitiRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/foodcost/schema': {
      id: '/_app/foodcost/schema'
      path: '/foodcost/schema'
      fullPath: '/foodcost/schema'
      preLoaderRoute: typeof AppFoodcostSchemaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/foodcost/mappature': {
      id: '/_app/foodcost/mappature'
      path: '/foodcost/mappature'
      fullPath: '/foodcost/mappature'
      preLoaderRoute: typeof AppFoodcostMappatureRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/foodcost/indicatori': {
      id: '/_app/foodcost/indicatori'
      path: '/foodcost/indicatori'
      fullPath: '/foodcost/indicatori'
      preLoaderRoute: typeof AppFoodcostIndicatoriRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/foodcost/cluster': {
      id: '/_app/foodcost/cluster'
      path: '/foodcost/cluster'
      fullPath: '/foodcost/cluster'
      preLoaderRoute: typeof AppFoodcostClusterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/foodcost/$periodoId': {
      id: '/_app/foodcost/$periodoId'
      path: '/foodcost/$periodoId'
      fullPath: '/foodcost/$periodoId'
      preLoaderRoute: typeof AppFoodcostPeriodoIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/$clientId': {
      id: '/_app/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/circulars/release-notes': {
      id: '/_app/circulars/release-notes'
      path: '/circulars/release-notes'
      fullPath: '/circulars/release-notes'
      preLoaderRoute: typeof AppCircularsReleaseNotesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/circulars/register': {
      id: '/_app/circulars/register'
      path: '/circulars/register'
      fullPath: '/circulars/register'
      preLoaderRoute: typeof AppCircularsRegisterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/new': {
      id: '/_app/bookings/new'
      path: '/bookings/new'
      fullPath: '/bookings/new'
      preLoaderRoute: typeof AppBookingsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/car-history': {
      id: '/_app/bookings/car-history'
      path: '/bookings/car-history'
      fullPath: '/bookings/car-history'
      preLoaderRoute: typeof AppBookingsCarHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/attendance_/team-month': {
      id: '/_app/attendance_/team-month'
      path: '/attendance/team-month'
      fullPath: '/attendance/team-month'
      preLoaderRoute: typeof AppAttendanceTeamMonthRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/articles_/$id': {
      id: '/_app/articles_/$id'
      path: '/articles/$id'
      fullPath: '/articles/$id'
      preLoaderRoute: typeof AppArticlesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/workflows': {
      id: '/_app/admin/workflows'
      path: '/admin/workflows'
      fullPath: '/admin/workflows'
      preLoaderRoute: typeof AppAdminWorkflowsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/travel-policies': {
      id: '/_app/admin/travel-policies'
      path: '/admin/travel-policies'
      fullPath: '/admin/travel-policies'
      preLoaderRoute: typeof AppAdminTravelPoliciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/translate-structure': {
      id: '/_app/admin/translate-structure'
      path: '/admin/translate-structure'
      fullPath: '/admin/translate-structure'
      preLoaderRoute: typeof AppAdminTranslateStructureRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/tenant-users': {
      id: '/_app/admin/tenant-users'
      path: '/admin/tenant-users'
      fullPath: '/admin/tenant-users'
      preLoaderRoute: typeof AppAdminTenantUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/tenant-management': {
      id: '/_app/admin/tenant-management'
      path: '/admin/tenant-management'
      fullPath: '/admin/tenant-management'
      preLoaderRoute: typeof AppAdminTenantManagementRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/tenant-attributes': {
      id: '/_app/admin/tenant-attributes'
      path: '/admin/tenant-attributes'
      fullPath: '/admin/tenant-attributes'
      preLoaderRoute: typeof AppAdminTenantAttributesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/task-rules': {
      id: '/_app/admin/task-rules'
      path: '/admin/task-rules'
      fullPath: '/admin/task-rules'
      preLoaderRoute: typeof AppAdminTaskRulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/task-labels': {
      id: '/_app/admin/task-labels'
      path: '/admin/task-labels'
      fullPath: '/admin/task-labels'
      preLoaderRoute: typeof AppAdminTaskLabelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/tardiness-policies': {
      id: '/_app/admin/tardiness-policies'
      path: '/admin/tardiness-policies'
      fullPath: '/admin/tardiness-policies'
      preLoaderRoute: typeof AppAdminTardinessPoliciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/system': {
      id: '/_app/admin/system'
      path: '/admin/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AppAdminSystemRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/support-topics': {
      id: '/_app/admin/support-topics'
      path: '/admin/support-topics'
      fullPath: '/admin/support-topics'
      preLoaderRoute: typeof AppAdminSupportTopicsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/subscription-types': {
      id: '/_app/admin/subscription-types'
      path: '/admin/subscription-types'
      fullPath: '/admin/subscription-types'
      preLoaderRoute: typeof AppAdminSubscriptionTypesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/structure-labels': {
      id: '/_app/admin/structure-labels'
      path: '/admin/structure-labels'
      fullPath: '/admin/structure-labels'
      preLoaderRoute: typeof AppAdminStructureLabelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/smart-working-config': {
      id: '/_app/admin/smart-working-config'
      path: '/admin/smart-working-config'
      fullPath: '/admin/smart-working-config'
      preLoaderRoute: typeof AppAdminSmartWorkingConfigRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/send-communications': {
      id: '/_app/admin/send-communications'
      path: '/admin/send-communications'
      fullPath: '/admin/send-communications'
      preLoaderRoute: typeof AppAdminSendCommunicationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/protected-statuses': {
      id: '/_app/admin/protected-statuses'
      path: '/admin/protected-statuses'
      fullPath: '/admin/protected-statuses'
      preLoaderRoute: typeof AppAdminProtectedStatusesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/project-type-presets': {
      id: '/_app/admin/project-type-presets'
      path: '/admin/project-type-presets'
      fullPath: '/admin/project-type-presets'
      preLoaderRoute: typeof AppAdminProjectTypePresetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/project-categories': {
      id: '/_app/admin/project-categories'
      path: '/admin/project-categories'
      fullPath: '/admin/project-categories'
      preLoaderRoute: typeof AppAdminProjectCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/project-attribute-definitions': {
      id: '/_app/admin/project-attribute-definitions'
      path: '/admin/project-attribute-definitions'
      fullPath: '/admin/project-attribute-definitions'
      preLoaderRoute: typeof AppAdminProjectAttributeDefinitionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/portal-pages': {
      id: '/_app/admin/portal-pages'
      path: '/admin/portal-pages'
      fullPath: '/admin/portal-pages'
      preLoaderRoute: typeof AppAdminPortalPagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/portal-documents': {
      id: '/_app/admin/portal-documents'
      path: '/admin/portal-documents'
      fullPath: '/admin/portal-documents'
      preLoaderRoute: typeof AppAdminPortalDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/policies': {
      id: '/_app/admin/policies'
      path: '/admin/policies'
      fullPath: '/admin/policies'
      preLoaderRoute: typeof AppAdminPoliciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/planning-policies': {
      id: '/_app/admin/planning-policies'
      path: '/admin/planning-policies'
      fullPath: '/admin/planning-policies'
      preLoaderRoute: typeof AppAdminPlanningPoliciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/modules': {
      id: '/_app/admin/modules'
      path: '/admin/modules'
      fullPath: '/admin/modules'
      preLoaderRoute: typeof AppAdminModulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/mileage-rates': {
      id: '/_app/admin/mileage-rates'
      path: '/admin/mileage-rates'
      fullPath: '/admin/mileage-rates'
      preLoaderRoute: typeof AppAdminMileageRatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/mcp-connections': {
      id: '/_app/admin/mcp-connections'
      path: '/admin/mcp-connections'
      fullPath: '/admin/mcp-connections'
      preLoaderRoute: typeof AppAdminMcpConnectionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/maintenance': {
      id: '/_app/admin/maintenance'
      path: '/admin/maintenance'
      fullPath: '/admin/maintenance'
      preLoaderRoute: typeof AppAdminMaintenanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/logs': {
      id: '/_app/admin/logs'
      path: '/admin/logs'
      fullPath: '/admin/logs'
      preLoaderRoute: typeof AppAdminLogsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/licenses-catalog': {
      id: '/_app/admin/licenses-catalog'
      path: '/admin/licenses-catalog'
      fullPath: '/admin/licenses-catalog'
      preLoaderRoute: typeof AppAdminLicensesCatalogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/license-plans': {
      id: '/_app/admin/license-plans'
      path: '/admin/license-plans'
      fullPath: '/admin/license-plans'
      preLoaderRoute: typeof AppAdminLicensePlansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/license-dashboard': {
      id: '/_app/admin/license-dashboard'
      path: '/admin/license-dashboard'
      fullPath: '/admin/license-dashboard'
      preLoaderRoute: typeof AppAdminLicenseDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/leave-config': {
      id: '/_app/admin/leave-config'
      path: '/admin/leave-config'
      fullPath: '/admin/leave-config'
      preLoaderRoute: typeof AppAdminLeaveConfigRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/jobs': {
      id: '/_app/admin/jobs'
      path: '/admin/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AppAdminJobsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/email-log': {
      id: '/_app/admin/email-log'
      path: '/admin/email-log'
      fullPath: '/admin/email-log'
      preLoaderRoute: typeof AppAdminEmailLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/cross-tenant-access-logs': {
      id: '/_app/admin/cross-tenant-access-logs'
      path: '/admin/cross-tenant-access-logs'
      fullPath: '/admin/cross-tenant-access-logs'
      preLoaderRoute: typeof AppAdminCrossTenantAccessLogsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/connectors': {
      id: '/_app/admin/connectors'
      path: '/admin/connectors'
      fullPath: '/admin/connectors'
      preLoaderRoute: typeof AppAdminConnectorsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/client-intake': {
      id: '/_app/admin/client-intake'
      path: '/admin/client-intake'
      fullPath: '/admin/client-intake'
      preLoaderRoute: typeof AppAdminClientIntakeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/categories': {
      id: '/_app/admin/categories'
      path: '/admin/categories'
      fullPath: '/admin/categories'
      preLoaderRoute: typeof AppAdminCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/branding': {
      id: '/_app/admin/branding'
      path: '/admin/branding'
      fullPath: '/admin/branding'
      preLoaderRoute: typeof AppAdminBrandingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/board-config': {
      id: '/_app/admin/board-config'
      path: '/admin/board-config'
      fullPath: '/admin/board-config'
      preLoaderRoute: typeof AppAdminBoardConfigRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/audit-log': {
      id: '/_app/admin/audit-log'
      path: '/admin/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AppAdminAuditLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/attendance-sources': {
      id: '/_app/admin/attendance-sources'
      path: '/admin/attendance-sources'
      fullPath: '/admin/attendance-sources'
      preLoaderRoute: typeof AppAdminAttendanceSourcesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/attendance-reminders': {
      id: '/_app/admin/attendance-reminders'
      path: '/admin/attendance-reminders'
      fullPath: '/admin/attendance-reminders'
      preLoaderRoute: typeof AppAdminAttendanceRemindersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workforce/sites/': {
      id: '/_app/workforce/sites/'
      path: '/sites'
      fullPath: '/workforce/sites/'
      preLoaderRoute: typeof AppWorkforceSitesIndexRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/admin/tenants/': {
      id: '/_app/admin/tenants/'
      path: '/admin/tenants'
      fullPath: '/admin/tenants/'
      preLoaderRoute: typeof AppAdminTenantsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workforce/sites/$siteId': {
      id: '/_app/workforce/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/workforce/sites/$siteId'
      preLoaderRoute: typeof AppWorkforceSitesSiteIdRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/projects/$projectId/dashboard': {
      id: '/_app/projects/$projectId/dashboard'
      path: '/dashboard'
      fullPath: '/projects/$projectId/dashboard'
      preLoaderRoute: typeof AppProjectsProjectIdDashboardRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/foodcost/scheda/$periodoId': {
      id: '/_app/foodcost/scheda/$periodoId'
      path: '/foodcost/scheda/$periodoId'
      fullPath: '/foodcost/scheda/$periodoId'
      preLoaderRoute: typeof AppFoodcostSchedaPeriodoIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/foodcost/portale/$clienteId': {
      id: '/_app/foodcost/portale/$clienteId'
      path: '/foodcost/portale/$clienteId'
      fullPath: '/foodcost/portale/$clienteId'
      preLoaderRoute: typeof AppFoodcostPortaleClienteIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/tenants/group': {
      id: '/_app/admin/tenants/group'
      path: '/admin/tenants/group'
      fullPath: '/admin/tenants/group'
      preLoaderRoute: typeof AppAdminTenantsGroupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/tenants/$tenantId': {
      id: '/_app/admin/tenants/$tenantId'
      path: '/admin/tenants/$tenantId'
      fullPath: '/admin/tenants/$tenantId'
      preLoaderRoute: typeof AppAdminTenantsTenantIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/tenants/$tenantId/subscription': {
      id: '/_app/admin/tenants/$tenantId/subscription'
      path: '/subscription'
      fullPath: '/admin/tenants/$tenantId/subscription'
      preLoaderRoute: typeof AppAdminTenantsTenantIdSubscriptionRouteImport
      parentRoute: typeof AppAdminTenantsTenantIdRoute
    }
  }
}

interface AppProjectsProjectIdRouteChildren {
  AppProjectsProjectIdDashboardRoute: typeof AppProjectsProjectIdDashboardRoute
}

const AppProjectsProjectIdRouteChildren: AppProjectsProjectIdRouteChildren = {
  AppProjectsProjectIdDashboardRoute: AppProjectsProjectIdDashboardRoute,
}

const AppProjectsProjectIdRouteWithChildren =
  AppProjectsProjectIdRoute._addFileChildren(AppProjectsProjectIdRouteChildren)

interface AppProjectsRouteRouteChildren {
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRouteWithChildren
  AppProjectsGanttRoute: typeof AppProjectsGanttRoute
  AppProjectsNewRoute: typeof AppProjectsNewRoute
  AppProjectsWbsRoute: typeof AppProjectsWbsRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppProjectsRouteRouteChildren: AppProjectsRouteRouteChildren = {
  AppProjectsProjectIdRoute: AppProjectsProjectIdRouteWithChildren,
  AppProjectsGanttRoute: AppProjectsGanttRoute,
  AppProjectsNewRoute: AppProjectsNewRoute,
  AppProjectsWbsRoute: AppProjectsWbsRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppProjectsRouteRouteWithChildren =
  AppProjectsRouteRoute._addFileChildren(AppProjectsRouteRouteChildren)

interface AppRolesRouteRouteChildren {
  AppRolesRoleIdRoute: typeof AppRolesRoleIdRoute
  AppRolesIndexRoute: typeof AppRolesIndexRoute
}

const AppRolesRouteRouteChildren: AppRolesRouteRouteChildren = {
  AppRolesRoleIdRoute: AppRolesRoleIdRoute,
  AppRolesIndexRoute: AppRolesIndexRoute,
}

const AppRolesRouteRouteWithChildren = AppRolesRouteRoute._addFileChildren(
  AppRolesRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsApiKeysRoute: typeof AppSettingsApiKeysRoute
  AppSettingsDevicesRoute: typeof AppSettingsDevicesRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsNotificationPreferencesRoute: typeof AppSettingsNotificationPreferencesRoute
  AppSettingsPreferencesRoute: typeof AppSettingsPreferencesRoute
  AppSettingsPrivacyRoute: typeof AppSettingsPrivacyRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsProtectedDataRoute: typeof AppSettingsProtectedDataRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsApiKeysRoute: AppSettingsApiKeysRoute,
  AppSettingsDevicesRoute: AppSettingsDevicesRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsNotificationPreferencesRoute:
    AppSettingsNotificationPreferencesRoute,
  AppSettingsPreferencesRoute: AppSettingsPreferencesRoute,
  AppSettingsPrivacyRoute: AppSettingsPrivacyRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsProtectedDataRoute: AppSettingsProtectedDataRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppTemplatesRouteRouteChildren {
  AppTemplatesTemplateIdRoute: typeof AppTemplatesTemplateIdRoute
  AppTemplatesIndexRoute: typeof AppTemplatesIndexRoute
}

const AppTemplatesRouteRouteChildren: AppTemplatesRouteRouteChildren = {
  AppTemplatesTemplateIdRoute: AppTemplatesTemplateIdRoute,
  AppTemplatesIndexRoute: AppTemplatesIndexRoute,
}

const AppTemplatesRouteRouteWithChildren =
  AppTemplatesRouteRoute._addFileChildren(AppTemplatesRouteRouteChildren)

interface AppTimesheetRouteRouteChildren {
  AppTimesheetAdminRoute: typeof AppTimesheetAdminRoute
  AppTimesheetApprovalRoute: typeof AppTimesheetApprovalRoute
  AppTimesheetByProjectRoute: typeof AppTimesheetByProjectRoute
  AppTimesheetNewRoute: typeof AppTimesheetNewRoute
  AppTimesheetReasonsRoute: typeof AppTimesheetReasonsRoute
  AppTimesheetIndexRoute: typeof AppTimesheetIndexRoute
}

const AppTimesheetRouteRouteChildren: AppTimesheetRouteRouteChildren = {
  AppTimesheetAdminRoute: AppTimesheetAdminRoute,
  AppTimesheetApprovalRoute: AppTimesheetApprovalRoute,
  AppTimesheetByProjectRoute: AppTimesheetByProjectRoute,
  AppTimesheetNewRoute: AppTimesheetNewRoute,
  AppTimesheetReasonsRoute: AppTimesheetReasonsRoute,
  AppTimesheetIndexRoute: AppTimesheetIndexRoute,
}

const AppTimesheetRouteRouteWithChildren =
  AppTimesheetRouteRoute._addFileChildren(AppTimesheetRouteRouteChildren)

interface AppUsersRouteRouteChildren {
  AppUsersUserIdRoute: typeof AppUsersUserIdRoute
  AppUsersNewRoute: typeof AppUsersNewRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
}

const AppUsersRouteRouteChildren: AppUsersRouteRouteChildren = {
  AppUsersUserIdRoute: AppUsersUserIdRoute,
  AppUsersNewRoute: AppUsersNewRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
}

const AppUsersRouteRouteWithChildren = AppUsersRouteRoute._addFileChildren(
  AppUsersRouteRouteChildren,
)

interface AppWarehouseRouteRouteChildren {
  AppWarehouseAttributesRoute: typeof AppWarehouseAttributesRoute
  AppWarehouseDocumentsRoute: typeof AppWarehouseDocumentsRoute
  AppWarehouseInventoryRoute: typeof AppWarehouseInventoryRoute
  AppWarehouseItemsRoute: typeof AppWarehouseItemsRoute
  AppWarehouseLocationsRoute: typeof AppWarehouseLocationsRoute
  AppWarehouseLotsRoute: typeof AppWarehouseLotsRoute
  AppWarehouseWarehousesRoute: typeof AppWarehouseWarehousesRoute
  AppWarehouseIndexRoute: typeof AppWarehouseIndexRoute
}

const AppWarehouseRouteRouteChildren: AppWarehouseRouteRouteChildren = {
  AppWarehouseAttributesRoute: AppWarehouseAttributesRoute,
  AppWarehouseDocumentsRoute: AppWarehouseDocumentsRoute,
  AppWarehouseInventoryRoute: AppWarehouseInventoryRoute,
  AppWarehouseItemsRoute: AppWarehouseItemsRoute,
  AppWarehouseLocationsRoute: AppWarehouseLocationsRoute,
  AppWarehouseLotsRoute: AppWarehouseLotsRoute,
  AppWarehouseWarehousesRoute: AppWarehouseWarehousesRoute,
  AppWarehouseIndexRoute: AppWarehouseIndexRoute,
}

const AppWarehouseRouteRouteWithChildren =
  AppWarehouseRouteRoute._addFileChildren(AppWarehouseRouteRouteChildren)

interface AppWorkforceRouteRouteChildren {
  AppWorkforceEmployeeIdRoute: typeof AppWorkforceEmployeeIdRoute
  AppWorkforceBuRoute: typeof AppWorkforceBuRoute
  AppWorkforceDashboardRoute: typeof AppWorkforceDashboardRoute
  AppWorkforceExternalRoute: typeof AppWorkforceExternalRoute
  AppWorkforceHierarchyRoute: typeof AppWorkforceHierarchyRoute
  AppWorkforceRolesRoute: typeof AppWorkforceRolesRoute
  AppWorkforceSitePresencesRoute: typeof AppWorkforceSitePresencesRoute
  AppWorkforceTodayRoute: typeof AppWorkforceTodayRoute
  AppWorkforceTrainingRoute: typeof AppWorkforceTrainingRoute
  AppWorkforceIndexRoute: typeof AppWorkforceIndexRoute
  AppWorkforceSitesSiteIdRoute: typeof AppWorkforceSitesSiteIdRoute
  AppWorkforceSitesIndexRoute: typeof AppWorkforceSitesIndexRoute
}

const AppWorkforceRouteRouteChildren: AppWorkforceRouteRouteChildren = {
  AppWorkforceEmployeeIdRoute: AppWorkforceEmployeeIdRoute,
  AppWorkforceBuRoute: AppWorkforceBuRoute,
  AppWorkforceDashboardRoute: AppWorkforceDashboardRoute,
  AppWorkforceExternalRoute: AppWorkforceExternalRoute,
  AppWorkforceHierarchyRoute: AppWorkforceHierarchyRoute,
  AppWorkforceRolesRoute: AppWorkforceRolesRoute,
  AppWorkforceSitePresencesRoute: AppWorkforceSitePresencesRoute,
  AppWorkforceTodayRoute: AppWorkforceTodayRoute,
  AppWorkforceTrainingRoute: AppWorkforceTrainingRoute,
  AppWorkforceIndexRoute: AppWorkforceIndexRoute,
  AppWorkforceSitesSiteIdRoute: AppWorkforceSitesSiteIdRoute,
  AppWorkforceSitesIndexRoute: AppWorkforceSitesIndexRoute,
}

const AppWorkforceRouteRouteWithChildren =
  AppWorkforceRouteRoute._addFileChildren(AppWorkforceRouteRouteChildren)

interface AppInsightsRouteChildren {
  AppInsightsMonthlyInvoicesRoute: typeof AppInsightsMonthlyInvoicesRoute
  AppInsightsSubscriptionsRoute: typeof AppInsightsSubscriptionsRoute
}

const AppInsightsRouteChildren: AppInsightsRouteChildren = {
  AppInsightsMonthlyInvoicesRoute: AppInsightsMonthlyInvoicesRoute,
  AppInsightsSubscriptionsRoute: AppInsightsSubscriptionsRoute,
}

const AppInsightsRouteWithChildren = AppInsightsRoute._addFileChildren(
  AppInsightsRouteChildren,
)

interface AppInstrumentsCalendarRouteChildren {
  AppInstrumentsCalendarApprovalsRoute: typeof AppInstrumentsCalendarApprovalsRoute
  AppInstrumentsCalendarIndexRoute: typeof AppInstrumentsCalendarIndexRoute
}

const AppInstrumentsCalendarRouteChildren: AppInstrumentsCalendarRouteChildren =
  {
    AppInstrumentsCalendarApprovalsRoute: AppInstrumentsCalendarApprovalsRoute,
    AppInstrumentsCalendarIndexRoute: AppInstrumentsCalendarIndexRoute,
  }

const AppInstrumentsCalendarRouteWithChildren =
  AppInstrumentsCalendarRoute._addFileChildren(
    AppInstrumentsCalendarRouteChildren,
  )

interface AppLeaveRouteChildren {
  AppLeaveApprovalsRoute: typeof AppLeaveApprovalsRoute
  AppLeaveNewRoute: typeof AppLeaveNewRoute
  AppLeaveIndexRoute: typeof AppLeaveIndexRoute
}

const AppLeaveRouteChildren: AppLeaveRouteChildren = {
  AppLeaveApprovalsRoute: AppLeaveApprovalsRoute,
  AppLeaveNewRoute: AppLeaveNewRoute,
  AppLeaveIndexRoute: AppLeaveIndexRoute,
}

const AppLeaveRouteWithChildren = AppLeaveRoute._addFileChildren(
  AppLeaveRouteChildren,
)

interface AppNotificationsRouteChildren {
  AppNotificationsNotificationIdRoute: typeof AppNotificationsNotificationIdRoute
  AppNotificationsIndexRoute: typeof AppNotificationsIndexRoute
}

const AppNotificationsRouteChildren: AppNotificationsRouteChildren = {
  AppNotificationsNotificationIdRoute: AppNotificationsNotificationIdRoute,
  AppNotificationsIndexRoute: AppNotificationsIndexRoute,
}

const AppNotificationsRouteWithChildren =
  AppNotificationsRoute._addFileChildren(AppNotificationsRouteChildren)

interface AppPlanningRouteChildren {
  AppPlanningNewRoute: typeof AppPlanningNewRoute
  AppPlanningIndexRoute: typeof AppPlanningIndexRoute
}

const AppPlanningRouteChildren: AppPlanningRouteChildren = {
  AppPlanningNewRoute: AppPlanningNewRoute,
  AppPlanningIndexRoute: AppPlanningIndexRoute,
}

const AppPlanningRouteWithChildren = AppPlanningRoute._addFileChildren(
  AppPlanningRouteChildren,
)

interface AppSmartWorkingRouteChildren {
  AppSmartWorkingApprovalsRoute: typeof AppSmartWorkingApprovalsRoute
  AppSmartWorkingIndexRoute: typeof AppSmartWorkingIndexRoute
}

const AppSmartWorkingRouteChildren: AppSmartWorkingRouteChildren = {
  AppSmartWorkingApprovalsRoute: AppSmartWorkingApprovalsRoute,
  AppSmartWorkingIndexRoute: AppSmartWorkingIndexRoute,
}

const AppSmartWorkingRouteWithChildren = AppSmartWorkingRoute._addFileChildren(
  AppSmartWorkingRouteChildren,
)

interface AppTasksRouteChildren {
  AppTasksTaskIdRoute: typeof AppTasksTaskIdRoute
  AppTasksCapacityRoute: typeof AppTasksCapacityRoute
  AppTasksCardRoute: typeof AppTasksCardRoute
  AppTasksDashboardRoute: typeof AppTasksDashboardRoute
  AppTasksGanttRoute: typeof AppTasksGanttRoute
  AppTasksGanttInteractiveRoute: typeof AppTasksGanttInteractiveRoute
  AppTasksKanbanRoute: typeof AppTasksKanbanRoute
  AppTasksListRoute: typeof AppTasksListRoute
  AppTasksNewRoute: typeof AppTasksNewRoute
  AppTasksNotesRoute: typeof AppTasksNotesRoute
  AppTasksPlanRoute: typeof AppTasksPlanRoute
  AppTasksWbsRoute: typeof AppTasksWbsRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
}

const AppTasksRouteChildren: AppTasksRouteChildren = {
  AppTasksTaskIdRoute: AppTasksTaskIdRoute,
  AppTasksCapacityRoute: AppTasksCapacityRoute,
  AppTasksCardRoute: AppTasksCardRoute,
  AppTasksDashboardRoute: AppTasksDashboardRoute,
  AppTasksGanttRoute: AppTasksGanttRoute,
  AppTasksGanttInteractiveRoute: AppTasksGanttInteractiveRoute,
  AppTasksKanbanRoute: AppTasksKanbanRoute,
  AppTasksListRoute: AppTasksListRoute,
  AppTasksNewRoute: AppTasksNewRoute,
  AppTasksNotesRoute: AppTasksNotesRoute,
  AppTasksPlanRoute: AppTasksPlanRoute,
  AppTasksWbsRoute: AppTasksWbsRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
}

const AppTasksRouteWithChildren = AppTasksRoute._addFileChildren(
  AppTasksRouteChildren,
)

interface AppTestPlansRouteChildren {
  AppTestPlansPlanIdRoute: typeof AppTestPlansPlanIdRoute
  AppTestPlansIndexRoute: typeof AppTestPlansIndexRoute
}

const AppTestPlansRouteChildren: AppTestPlansRouteChildren = {
  AppTestPlansPlanIdRoute: AppTestPlansPlanIdRoute,
  AppTestPlansIndexRoute: AppTestPlansIndexRoute,
}

const AppTestPlansRouteWithChildren = AppTestPlansRoute._addFileChildren(
  AppTestPlansRouteChildren,
)

interface AppAdminTenantsTenantIdRouteChildren {
  AppAdminTenantsTenantIdSubscriptionRoute: typeof AppAdminTenantsTenantIdSubscriptionRoute
}

const AppAdminTenantsTenantIdRouteChildren: AppAdminTenantsTenantIdRouteChildren =
  {
    AppAdminTenantsTenantIdSubscriptionRoute:
      AppAdminTenantsTenantIdSubscriptionRoute,
  }

const AppAdminTenantsTenantIdRouteWithChildren =
  AppAdminTenantsTenantIdRoute._addFileChildren(
    AppAdminTenantsTenantIdRouteChildren,
  )

interface AppRouteChildren {
  AppProjectsRouteRoute: typeof AppProjectsRouteRouteWithChildren
  AppRolesRouteRoute: typeof AppRolesRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppTemplatesRouteRoute: typeof AppTemplatesRouteRouteWithChildren
  AppTimesheetRouteRoute: typeof AppTimesheetRouteRouteWithChildren
  AppUsersRouteRoute: typeof AppUsersRouteRouteWithChildren
  AppWarehouseRouteRoute: typeof AppWarehouseRouteRouteWithChildren
  AppWorkforceRouteRoute: typeof AppWorkforceRouteRouteWithChildren
  AppAboutRoute: typeof AppAboutRoute
  AppAppAndroidRoute: typeof AppAppAndroidRoute
  AppApprovalsRoute: typeof AppApprovalsRoute
  AppArticlesRoute: typeof AppArticlesRoute
  AppAttendanceRoute: typeof AppAttendanceRoute
  AppBillingRoute: typeof AppBillingRoute
  AppCarHistoryRoute: typeof AppCarHistoryRoute
  AppChangelogRoute: typeof AppChangelogRoute
  AppConfigurationRoute: typeof AppConfigurationRoute
  AppDeveloperGuideRoute: typeof AppDeveloperGuideRoute
  AppExpenseReportsRoute: typeof AppExpenseReportsRoute
  AppFleetRoute: typeof AppFleetRoute
  AppGeneralCrudRoute: typeof AppGeneralCrudRoute
  AppGroupRulesRoute: typeof AppGroupRulesRoute
  AppHelpRoute: typeof AppHelpRoute
  AppInsightsRoute: typeof AppInsightsRouteWithChildren
  AppInstrumentsCalendarRoute: typeof AppInstrumentsCalendarRouteWithChildren
  AppIntercompanyRoute: typeof AppIntercompanyRoute
  AppLeaveRoute: typeof AppLeaveRouteWithChildren
  AppLegalNoticesRoute: typeof AppLegalNoticesRoute
  AppLegalsRoute: typeof AppLegalsRoute
  AppLicensingRoute: typeof AppLicensingRoute
  AppMaeworldRoute: typeof AppMaeworldRoute
  AppMediaRoute: typeof AppMediaRoute
  AppMySubscriptionsRoute: typeof AppMySubscriptionsRoute
  AppMyVehiclesRoute: typeof AppMyVehiclesRoute
  AppMyViolationsRoute: typeof AppMyViolationsRoute
  AppNotesRoute: typeof AppNotesRoute
  AppNotificationsRoute: typeof AppNotificationsRouteWithChildren
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppOpenAppRoute: typeof AppOpenAppRoute
  AppPlanningRoute: typeof AppPlanningRouteWithChildren
  AppProductsRoute: typeof AppProductsRoute
  AppProjectForecastRoute: typeof AppProjectForecastRoute
  AppQualityRoute: typeof AppQualityRoute
  AppReportingRoute: typeof AppReportingRoute
  AppServiceReportsRoute: typeof AppServiceReportsRoute
  AppSetupRoute: typeof AppSetupRoute
  AppShiftSwapsRoute: typeof AppShiftSwapsRoute
  AppSmartWorkingRoute: typeof AppSmartWorkingRouteWithChildren
  AppSprintRoute: typeof AppSprintRoute
  AppStatisticsRoute: typeof AppStatisticsRoute
  AppSupportRoute: typeof AppSupportRoute
  AppSupportIntakeRoute: typeof AppSupportIntakeRoute
  AppSwitchTenantRoute: typeof AppSwitchTenantRoute
  AppTasksRoute: typeof AppTasksRouteWithChildren
  AppTeamCalendarRoute: typeof AppTeamCalendarRoute
  AppTeamDeadlinesRoute: typeof AppTeamDeadlinesRoute
  AppTestCasesRoute: typeof AppTestCasesRoute
  AppTestCoverageRoute: typeof AppTestCoverageRoute
  AppTestPlansRoute: typeof AppTestPlansRouteWithChildren
  AppTicketsRoute: typeof AppTicketsRoute
  AppTranslateStructureRoute: typeof AppTranslateStructureRoute
  AppTranslationsRoute: typeof AppTranslationsRoute
  AppTravelRoute: typeof AppTravelRoute
  AppUpdateAppRoute: typeof AppUpdateAppRoute
  AppUploadAttachmentsRoute: typeof AppUploadAttachmentsRoute
  AppUserAuditRoute: typeof AppUserAuditRoute
  AppUserGuideRoute: typeof AppUserGuideRoute
  AppVehicleBookingsRoute: typeof AppVehicleBookingsRoute
  AppVehiclesRoute: typeof AppVehiclesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminAttendanceRemindersRoute: typeof AppAdminAttendanceRemindersRoute
  AppAdminAttendanceSourcesRoute: typeof AppAdminAttendanceSourcesRoute
  AppAdminAuditLogRoute: typeof AppAdminAuditLogRoute
  AppAdminBoardConfigRoute: typeof AppAdminBoardConfigRoute
  AppAdminBrandingRoute: typeof AppAdminBrandingRoute
  AppAdminCategoriesRoute: typeof AppAdminCategoriesRoute
  AppAdminClientIntakeRoute: typeof AppAdminClientIntakeRoute
  AppAdminConnectorsRoute: typeof AppAdminConnectorsRoute
  AppAdminCrossTenantAccessLogsRoute: typeof AppAdminCrossTenantAccessLogsRoute
  AppAdminEmailLogRoute: typeof AppAdminEmailLogRoute
  AppAdminJobsRoute: typeof AppAdminJobsRoute
  AppAdminLeaveConfigRoute: typeof AppAdminLeaveConfigRoute
  AppAdminLicenseDashboardRoute: typeof AppAdminLicenseDashboardRoute
  AppAdminLicensePlansRoute: typeof AppAdminLicensePlansRoute
  AppAdminLicensesCatalogRoute: typeof AppAdminLicensesCatalogRoute
  AppAdminLogsRoute: typeof AppAdminLogsRoute
  AppAdminMaintenanceRoute: typeof AppAdminMaintenanceRoute
  AppAdminMcpConnectionsRoute: typeof AppAdminMcpConnectionsRoute
  AppAdminMileageRatesRoute: typeof AppAdminMileageRatesRoute
  AppAdminModulesRoute: typeof AppAdminModulesRoute
  AppAdminPlanningPoliciesRoute: typeof AppAdminPlanningPoliciesRoute
  AppAdminPoliciesRoute: typeof AppAdminPoliciesRoute
  AppAdminPortalDocumentsRoute: typeof AppAdminPortalDocumentsRoute
  AppAdminPortalPagesRoute: typeof AppAdminPortalPagesRoute
  AppAdminProjectAttributeDefinitionsRoute: typeof AppAdminProjectAttributeDefinitionsRoute
  AppAdminProjectCategoriesRoute: typeof AppAdminProjectCategoriesRoute
  AppAdminProjectTypePresetsRoute: typeof AppAdminProjectTypePresetsRoute
  AppAdminProtectedStatusesRoute: typeof AppAdminProtectedStatusesRoute
  AppAdminSendCommunicationsRoute: typeof AppAdminSendCommunicationsRoute
  AppAdminSmartWorkingConfigRoute: typeof AppAdminSmartWorkingConfigRoute
  AppAdminStructureLabelsRoute: typeof AppAdminStructureLabelsRoute
  AppAdminSubscriptionTypesRoute: typeof AppAdminSubscriptionTypesRoute
  AppAdminSupportTopicsRoute: typeof AppAdminSupportTopicsRoute
  AppAdminSystemRoute: typeof AppAdminSystemRoute
  AppAdminTardinessPoliciesRoute: typeof AppAdminTardinessPoliciesRoute
  AppAdminTaskLabelsRoute: typeof AppAdminTaskLabelsRoute
  AppAdminTaskRulesRoute: typeof AppAdminTaskRulesRoute
  AppAdminTenantAttributesRoute: typeof AppAdminTenantAttributesRoute
  AppAdminTenantManagementRoute: typeof AppAdminTenantManagementRoute
  AppAdminTenantUsersRoute: typeof AppAdminTenantUsersRoute
  AppAdminTranslateStructureRoute: typeof AppAdminTranslateStructureRoute
  AppAdminTravelPoliciesRoute: typeof AppAdminTravelPoliciesRoute
  AppAdminWorkflowsRoute: typeof AppAdminWorkflowsRoute
  AppArticlesIdRoute: typeof AppArticlesIdRoute
  AppAttendanceTeamMonthRoute: typeof AppAttendanceTeamMonthRoute
  AppBookingsCarHistoryRoute: typeof AppBookingsCarHistoryRoute
  AppBookingsNewRoute: typeof AppBookingsNewRoute
  AppCircularsRegisterRoute: typeof AppCircularsRegisterRoute
  AppCircularsReleaseNotesRoute: typeof AppCircularsReleaseNotesRoute
  AppClientsClientIdRoute: typeof AppClientsClientIdRoute
  AppFoodcostPeriodoIdRoute: typeof AppFoodcostPeriodoIdRoute
  AppFoodcostClusterRoute: typeof AppFoodcostClusterRoute
  AppFoodcostIndicatoriRoute: typeof AppFoodcostIndicatoriRoute
  AppFoodcostMappatureRoute: typeof AppFoodcostMappatureRoute
  AppFoodcostSchemaRoute: typeof AppFoodcostSchemaRoute
  AppFoodcostSollecitiRoute: typeof AppFoodcostSollecitiRoute
  AppMcpAuthorizeRoute: typeof AppMcpAuthorizeRoute
  AppOrdersOrderIdRoute: typeof AppOrdersOrderIdRoute
  AppOrganizationCompanyRoute: typeof AppOrganizationCompanyRoute
  AppOrganizationCompanyDataRoute: typeof AppOrganizationCompanyDataRoute
  AppOrganizationEmployeesRoute: typeof AppOrganizationEmployeesRoute
  AppOrganizationPermissionsRoute: typeof AppOrganizationPermissionsRoute
  AppOrganizationWorkRulesRoute: typeof AppOrganizationWorkRulesRoute
  AppOrganizationWorkShiftsRoute: typeof AppOrganizationWorkShiftsRoute
  AppSecretaryAreaRoute: typeof AppSecretaryAreaRoute
  AppCircularsIndexRoute: typeof AppCircularsIndexRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppFoodcostIndexRoute: typeof AppFoodcostIndexRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
  AppAdminTenantsTenantIdRoute: typeof AppAdminTenantsTenantIdRouteWithChildren
  AppAdminTenantsGroupRoute: typeof AppAdminTenantsGroupRoute
  AppFoodcostPortaleClienteIdRoute: typeof AppFoodcostPortaleClienteIdRoute
  AppFoodcostSchedaPeriodoIdRoute: typeof AppFoodcostSchedaPeriodoIdRoute
  AppAdminTenantsIndexRoute: typeof AppAdminTenantsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppProjectsRouteRoute: AppProjectsRouteRouteWithChildren,
  AppRolesRouteRoute: AppRolesRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppTemplatesRouteRoute: AppTemplatesRouteRouteWithChildren,
  AppTimesheetRouteRoute: AppTimesheetRouteRouteWithChildren,
  AppUsersRouteRoute: AppUsersRouteRouteWithChildren,
  AppWarehouseRouteRoute: AppWarehouseRouteRouteWithChildren,
  AppWorkforceRouteRoute: AppWorkforceRouteRouteWithChildren,
  AppAboutRoute: AppAboutRoute,
  AppAppAndroidRoute: AppAppAndroidRoute,
  AppApprovalsRoute: AppApprovalsRoute,
  AppArticlesRoute: AppArticlesRoute,
  AppAttendanceRoute: AppAttendanceRoute,
  AppBillingRoute: AppBillingRoute,
  AppCarHistoryRoute: AppCarHistoryRoute,
  AppChangelogRoute: AppChangelogRoute,
  AppConfigurationRoute: AppConfigurationRoute,
  AppDeveloperGuideRoute: AppDeveloperGuideRoute,
  AppExpenseReportsRoute: AppExpenseReportsRoute,
  AppFleetRoute: AppFleetRoute,
  AppGeneralCrudRoute: AppGeneralCrudRoute,
  AppGroupRulesRoute: AppGroupRulesRoute,
  AppHelpRoute: AppHelpRoute,
  AppInsightsRoute: AppInsightsRouteWithChildren,
  AppInstrumentsCalendarRoute: AppInstrumentsCalendarRouteWithChildren,
  AppIntercompanyRoute: AppIntercompanyRoute,
  AppLeaveRoute: AppLeaveRouteWithChildren,
  AppLegalNoticesRoute: AppLegalNoticesRoute,
  AppLegalsRoute: AppLegalsRoute,
  AppLicensingRoute: AppLicensingRoute,
  AppMaeworldRoute: AppMaeworldRoute,
  AppMediaRoute: AppMediaRoute,
  AppMySubscriptionsRoute: AppMySubscriptionsRoute,
  AppMyVehiclesRoute: AppMyVehiclesRoute,
  AppMyViolationsRoute: AppMyViolationsRoute,
  AppNotesRoute: AppNotesRoute,
  AppNotificationsRoute: AppNotificationsRouteWithChildren,
  AppOnboardingRoute: AppOnboardingRoute,
  AppOpenAppRoute: AppOpenAppRoute,
  AppPlanningRoute: AppPlanningRouteWithChildren,
  AppProductsRoute: AppProductsRoute,
  AppProjectForecastRoute: AppProjectForecastRoute,
  AppQualityRoute: AppQualityRoute,
  AppReportingRoute: AppReportingRoute,
  AppServiceReportsRoute: AppServiceReportsRoute,
  AppSetupRoute: AppSetupRoute,
  AppShiftSwapsRoute: AppShiftSwapsRoute,
  AppSmartWorkingRoute: AppSmartWorkingRouteWithChildren,
  AppSprintRoute: AppSprintRoute,
  AppStatisticsRoute: AppStatisticsRoute,
  AppSupportRoute: AppSupportRoute,
  AppSupportIntakeRoute: AppSupportIntakeRoute,
  AppSwitchTenantRoute: AppSwitchTenantRoute,
  AppTasksRoute: AppTasksRouteWithChildren,
  AppTeamCalendarRoute: AppTeamCalendarRoute,
  AppTeamDeadlinesRoute: AppTeamDeadlinesRoute,
  AppTestCasesRoute: AppTestCasesRoute,
  AppTestCoverageRoute: AppTestCoverageRoute,
  AppTestPlansRoute: AppTestPlansRouteWithChildren,
  AppTicketsRoute: AppTicketsRoute,
  AppTranslateStructureRoute: AppTranslateStructureRoute,
  AppTranslationsRoute: AppTranslationsRoute,
  AppTravelRoute: AppTravelRoute,
  AppUpdateAppRoute: AppUpdateAppRoute,
  AppUploadAttachmentsRoute: AppUploadAttachmentsRoute,
  AppUserAuditRoute: AppUserAuditRoute,
  AppUserGuideRoute: AppUserGuideRoute,
  AppVehicleBookingsRoute: AppVehicleBookingsRoute,
  AppVehiclesRoute: AppVehiclesRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminAttendanceRemindersRoute: AppAdminAttendanceRemindersRoute,
  AppAdminAttendanceSourcesRoute: AppAdminAttendanceSourcesRoute,
  AppAdminAuditLogRoute: AppAdminAuditLogRoute,
  AppAdminBoardConfigRoute: AppAdminBoardConfigRoute,
  AppAdminBrandingRoute: AppAdminBrandingRoute,
  AppAdminCategoriesRoute: AppAdminCategoriesRoute,
  AppAdminClientIntakeRoute: AppAdminClientIntakeRoute,
  AppAdminConnectorsRoute: AppAdminConnectorsRoute,
  AppAdminCrossTenantAccessLogsRoute: AppAdminCrossTenantAccessLogsRoute,
  AppAdminEmailLogRoute: AppAdminEmailLogRoute,
  AppAdminJobsRoute: AppAdminJobsRoute,
  AppAdminLeaveConfigRoute: AppAdminLeaveConfigRoute,
  AppAdminLicenseDashboardRoute: AppAdminLicenseDashboardRoute,
  AppAdminLicensePlansRoute: AppAdminLicensePlansRoute,
  AppAdminLicensesCatalogRoute: AppAdminLicensesCatalogRoute,
  AppAdminLogsRoute: AppAdminLogsRoute,
  AppAdminMaintenanceRoute: AppAdminMaintenanceRoute,
  AppAdminMcpConnectionsRoute: AppAdminMcpConnectionsRoute,
  AppAdminMileageRatesRoute: AppAdminMileageRatesRoute,
  AppAdminModulesRoute: AppAdminModulesRoute,
  AppAdminPlanningPoliciesRoute: AppAdminPlanningPoliciesRoute,
  AppAdminPoliciesRoute: AppAdminPoliciesRoute,
  AppAdminPortalDocumentsRoute: AppAdminPortalDocumentsRoute,
  AppAdminPortalPagesRoute: AppAdminPortalPagesRoute,
  AppAdminProjectAttributeDefinitionsRoute:
    AppAdminProjectAttributeDefinitionsRoute,
  AppAdminProjectCategoriesRoute: AppAdminProjectCategoriesRoute,
  AppAdminProjectTypePresetsRoute: AppAdminProjectTypePresetsRoute,
  AppAdminProtectedStatusesRoute: AppAdminProtectedStatusesRoute,
  AppAdminSendCommunicationsRoute: AppAdminSendCommunicationsRoute,
  AppAdminSmartWorkingConfigRoute: AppAdminSmartWorkingConfigRoute,
  AppAdminStructureLabelsRoute: AppAdminStructureLabelsRoute,
  AppAdminSubscriptionTypesRoute: AppAdminSubscriptionTypesRoute,
  AppAdminSupportTopicsRoute: AppAdminSupportTopicsRoute,
  AppAdminSystemRoute: AppAdminSystemRoute,
  AppAdminTardinessPoliciesRoute: AppAdminTardinessPoliciesRoute,
  AppAdminTaskLabelsRoute: AppAdminTaskLabelsRoute,
  AppAdminTaskRulesRoute: AppAdminTaskRulesRoute,
  AppAdminTenantAttributesRoute: AppAdminTenantAttributesRoute,
  AppAdminTenantManagementRoute: AppAdminTenantManagementRoute,
  AppAdminTenantUsersRoute: AppAdminTenantUsersRoute,
  AppAdminTranslateStructureRoute: AppAdminTranslateStructureRoute,
  AppAdminTravelPoliciesRoute: AppAdminTravelPoliciesRoute,
  AppAdminWorkflowsRoute: AppAdminWorkflowsRoute,
  AppArticlesIdRoute: AppArticlesIdRoute,
  AppAttendanceTeamMonthRoute: AppAttendanceTeamMonthRoute,
  AppBookingsCarHistoryRoute: AppBookingsCarHistoryRoute,
  AppBookingsNewRoute: AppBookingsNewRoute,
  AppCircularsRegisterRoute: AppCircularsRegisterRoute,
  AppCircularsReleaseNotesRoute: AppCircularsReleaseNotesRoute,
  AppClientsClientIdRoute: AppClientsClientIdRoute,
  AppFoodcostPeriodoIdRoute: AppFoodcostPeriodoIdRoute,
  AppFoodcostClusterRoute: AppFoodcostClusterRoute,
  AppFoodcostIndicatoriRoute: AppFoodcostIndicatoriRoute,
  AppFoodcostMappatureRoute: AppFoodcostMappatureRoute,
  AppFoodcostSchemaRoute: AppFoodcostSchemaRoute,
  AppFoodcostSollecitiRoute: AppFoodcostSollecitiRoute,
  AppMcpAuthorizeRoute: AppMcpAuthorizeRoute,
  AppOrdersOrderIdRoute: AppOrdersOrderIdRoute,
  AppOrganizationCompanyRoute: AppOrganizationCompanyRoute,
  AppOrganizationCompanyDataRoute: AppOrganizationCompanyDataRoute,
  AppOrganizationEmployeesRoute: AppOrganizationEmployeesRoute,
  AppOrganizationPermissionsRoute: AppOrganizationPermissionsRoute,
  AppOrganizationWorkRulesRoute: AppOrganizationWorkRulesRoute,
  AppOrganizationWorkShiftsRoute: AppOrganizationWorkShiftsRoute,
  AppSecretaryAreaRoute: AppSecretaryAreaRoute,
  AppCircularsIndexRoute: AppCircularsIndexRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppFoodcostIndexRoute: AppFoodcostIndexRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
  AppAdminTenantsTenantIdRoute: AppAdminTenantsTenantIdRouteWithChildren,
  AppAdminTenantsGroupRoute: AppAdminTenantsGroupRoute,
  AppFoodcostPortaleClienteIdRoute: AppFoodcostPortaleClienteIdRoute,
  AppFoodcostSchedaPeriodoIdRoute: AppFoodcostSchedaPeriodoIdRoute,
  AppAdminTenantsIndexRoute: AppAdminTenantsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthAccessPermissionsRoute: typeof AuthAccessPermissionsRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthPasswordResetRoute: typeof AuthPasswordResetRoute
  AuthRecoveryPasswordRoute: typeof AuthRecoveryPasswordRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthRegisterOtpRoute: typeof AuthRegisterOtpRoute
  AuthSelectTenantRoute: typeof AuthSelectTenantRoute
  AuthUpdatePasswordRoute: typeof AuthUpdatePasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccessPermissionsRoute: AuthAccessPermissionsRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthPasswordResetRoute: AuthPasswordResetRoute,
  AuthRecoveryPasswordRoute: AuthRecoveryPasswordRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthRegisterOtpRoute: AuthRegisterOtpRoute,
  AuthSelectTenantRoute: AuthSelectTenantRoute,
  AuthUpdatePasswordRoute: AuthUpdatePasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PortalRouteChildren {
  PortalPortalModuloRoute: typeof PortalPortalModuloRoute
  PortalPortalAssistenzaRoute: typeof PortalPortalAssistenzaRoute
  PortalPortalAttivitaRoute: typeof PortalPortalAttivitaRoute
  PortalPortalAziendaRoute: typeof PortalPortalAziendaRoute
  PortalPortalCircularsRoute: typeof PortalPortalCircularsRoute
  PortalPortalCommesseRoute: typeof PortalPortalCommesseRoute
  PortalPortalDocumentiRoute: typeof PortalPortalDocumentiRoute
  PortalPortalFattureRoute: typeof PortalPortalFattureRoute
  PortalPortalNumeriRoute: typeof PortalPortalNumeriRoute
  PortalPortalOrdiniRoute: typeof PortalPortalOrdiniRoute
  PortalPortalProfiloRoute: typeof PortalPortalProfiloRoute
  PortalPortalVerbaliRoute: typeof PortalPortalVerbaliRoute
  PortalPortalIndexRoute: typeof PortalPortalIndexRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalPortalModuloRoute: PortalPortalModuloRoute,
  PortalPortalAssistenzaRoute: PortalPortalAssistenzaRoute,
  PortalPortalAttivitaRoute: PortalPortalAttivitaRoute,
  PortalPortalAziendaRoute: PortalPortalAziendaRoute,
  PortalPortalCircularsRoute: PortalPortalCircularsRoute,
  PortalPortalCommesseRoute: PortalPortalCommesseRoute,
  PortalPortalDocumentiRoute: PortalPortalDocumentiRoute,
  PortalPortalFattureRoute: PortalPortalFattureRoute,
  PortalPortalNumeriRoute: PortalPortalNumeriRoute,
  PortalPortalOrdiniRoute: PortalPortalOrdiniRoute,
  PortalPortalProfiloRoute: PortalPortalProfiloRoute,
  PortalPortalVerbaliRoute: PortalPortalVerbaliRoute,
  PortalPortalIndexRoute: PortalPortalIndexRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

interface PublicRouteChildren {
  PublicDownloadAppRoute: typeof PublicDownloadAppRoute
  PublicHelpDeskUnlogRoute: typeof PublicHelpDeskUnlogRoute
  PublicMaintenanceRoute: typeof PublicMaintenanceRoute
  PublicTenantFallbackRoute: typeof PublicTenantFallbackRoute
  PublicTermsCodeRoute: typeof PublicTermsCodeRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicDownloadAppRoute: PublicDownloadAppRoute,
  PublicHelpDeskUnlogRoute: PublicHelpDeskUnlogRoute,
  PublicMaintenanceRoute: PublicMaintenanceRoute,
  PublicTenantFallbackRoute: PublicTenantFallbackRoute,
  PublicTermsCodeRoute: PublicTermsCodeRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  PortalRoute: PortalRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
